export const countrys = [
    {
        id: 1,
        en: 'Angola',
        zhCn: '安哥拉',
        zhTw: '安哥拉',
        areaCode: '+244',
        countryCode: 'AGO',
        initial: 'agl',
        score: 0,
    },
    {
        id: 2,
        en: 'Afghanistan',
        zhCn: '阿富汗',
        zhTw: '阿富汗',
        areaCode: '+93',
        countryCode: 'AFG',
        initial: 'afh',
        score: 0,
    },
    {
        id: 3,
        en: 'Albania',
        zhCn: '阿尔巴尼亚',
        zhTw: '阿爾巴尼亞',
        areaCode: '+355',
        countryCode: 'ALB',
        initial: 'aebny',
        score: 0,
    },
    {
        id: 4,
        en: 'Algeria',
        zhCn: '阿尔及利亚',
        zhTw: '阿爾及利亞',
        areaCode: '+213',
        countryCode: 'DZA',
        initial: 'aejly',
        score: 0,
    },
    {
        id: 5,
        en: 'Andorra',
        zhCn: '安道尔',
        zhTw: '安道爾',
        areaCode: '+376',
        countryCode: 'AND',
        initial: 'adeghg',
        score: 0,
    },
    {
        id: 6,
        en: 'Anguilla',
        zhCn: '安圭拉',
        zhTw: '安圭拉',
        areaCode: '+1264',
        countryCode: 'AIA',
        initial: 'agld',
        score: 0,
    },
    {
        id: 7,
        en: 'Antigua and Barbuda',
        zhCn: '安提瓜和巴布达',
        zhTw: '安提瓜和巴布達',
        areaCode: '+1268',
        countryCode: 'ATG',
        initial: 'atghbbd',
        score: 0,
    },
    {
        id: 8,
        en: 'Argentina',
        zhCn: '阿根廷',
        zhTw: '阿根廷',
        areaCode: '+54',
        countryCode: 'ARG',
        initial: 'agt',
        score: 0,
    },
    {
        id: 9,
        en: 'Armenia',
        zhCn: '亚美尼亚',
        zhTw: '亞美尼亞',
        areaCode: '+374',
        countryCode: 'ARM',
        initial: 'ymny',
        score: 0,
    },
    {
        id: 10,
        en: 'Australia',
        zhCn: '澳大利亚',
        zhTw: '澳大利亞',
        areaCode: '+61',
        countryCode: 'AUS',
        initial: 'adly',
        score: 0,
    },
    {
        id: 11,
        en: 'Austria',
        zhCn: '奥地利',
        zhTw: '奧地利',
        areaCode: '+43',
        countryCode: 'AUT',
        initial: 'adl',
        score: 0,
    },
    {
        id: 12,
        en: 'Azerbaijan',
        zhCn: '阿塞拜疆',
        zhTw: '阿塞拜疆',
        areaCode: '+994',
        countryCode: 'AZE',
        initial: 'asbj',
        score: 0,
    },
    {
        id: 13,
        en: 'Bahamas',
        zhCn: '巴哈马',
        zhTw: '巴哈馬',
        areaCode: '+1242',
        countryCode: 'BHS',
        initial: 'bhm',
        score: 0,
    },
    {
        id: 14,
        en: 'Bahrain',
        zhCn: '巴林',
        zhTw: '巴林',
        areaCode: '+973',
        countryCode: 'BHR',
        initial: 'bl',
        score: 0,
    },
    {
        id: 15,
        en: 'Bangladesh',
        zhCn: '孟加拉国',
        zhTw: '孟加拉國',
        areaCode: '+880',
        countryCode: 'BGD',
        initial: 'mjlg',
        score: 0,
    },
    {
        id: 16,
        en: 'Barbados',
        zhCn: '巴巴多斯',
        zhTw: '巴巴多斯',
        areaCode: '+1246',
        countryCode: 'BRB',
        initial: 'bbds',
        score: 0,
    },
    {
        id: 17,
        en: 'Belarus',
        zhCn: '白俄罗斯',
        zhTw: '白俄羅斯',
        areaCode: '+375',
        countryCode: 'BLR',
        initial: 'bels',
        score: 0,
    },
    {
        id: 18,
        en: 'Belgium',
        zhCn: '比利时',
        zhTw: '比利時',
        areaCode: '+32',
        countryCode: 'BEL',
        initial: 'bls',
        score: 0,
    },
    {
        id: 19,
        en: 'Belize',
        zhCn: '伯利兹',
        zhTw: '伯利茲',
        areaCode: '+501',
        countryCode: 'BLZ',
        initial: 'blc',
        score: 0,
    },
    {
        id: 20,
        en: 'Benin',
        zhCn: '贝宁',
        zhTw: '貝寧',
        areaCode: '+229',
        countryCode: 'BEN',
        initial: 'bn',
        score: 0,
    },
    {
        id: 21,
        en: 'Bermuda Is.',
        zhCn: '百慕大',
        zhTw: '百慕大',
        areaCode: '+1441',
        countryCode: 'BMU',
        initial: 'bmdqd',
        score: 0,
    },
    {
        id: 22,
        en: 'Bolivia',
        zhCn: '玻利维亚州',
        zhTw: '玻利維亞州',
        areaCode: '+591',
        countryCode: 'BOL',
        initial: 'blwy',
        score: 0,
    },
    {
        id: 23,
        en: 'Botswana',
        zhCn: '博茨瓦纳',
        zhTw: '博茨瓦納',
        areaCode: '+267',
        countryCode: 'BWA',
        initial: 'bcwn',
        score: 0,
    },
    {
        id: 24,
        en: 'Brazil',
        zhCn: '巴西',
        zhTw: '巴西',
        areaCode: '+55',
        countryCode: 'BRA',
        initial: 'bx',
        score: 0,
    },
    {
        id: 25,
        en: 'Brunei',
        zhCn: '文莱达鲁萨兰国',
        zhTw: '文萊達魯薩蘭國',
        areaCode: '+673',
        countryCode: 'BRN',
        initial: 'wl',
        score: 0,
    },
    {
        id: 26,
        en: 'Bulgaria',
        zhCn: '保加利亚',
        zhTw: '保加利亞',
        areaCode: '+359',
        countryCode: 'BGR',
        initial: 'bjly',
        score: 0,
    },
    {
        id: 27,
        en: 'Burkinafaso',
        zhCn: '布基纳法索',
        zhTw: '布基納法索',
        areaCode: '+226',
        countryCode: 'BFA',
        initial: 'bjnfs',
        score: 0,
    },
    {
        id: 28,
        en: 'Burma',
        zhCn: '缅甸',
        zhTw: '緬甸',
        areaCode: '+95',
        countryCode: 'MMR',
        initial: 'md',
        score: 0,
    },
    {
        id: 29,
        en: 'Burundi',
        zhCn: '布隆迪',
        zhTw: '布隆迪',
        areaCode: '+257',
        countryCode: 'BDI',
        initial: 'bld',
        score: 0,
    },
    {
        id: 30,
        en: 'Cameroon',
        zhCn: '喀麦隆',
        zhTw: '喀麥隆',
        areaCode: '+237',
        countryCode: 'CMR',
        initial: 'kml',
        score: 0,
    },
    {
        id: 31,
        en: 'Canada',
        zhCn: '加拿大',
        zhTw: '加拿大',
        areaCode: '+1',
        countryCode: 'CAN',
        initial: 'jnd',
        score: 0,
    },
    {
        id: 32,
        en: 'Cayman Is.',
        zhCn: '开曼群岛',
        zhTw: '開曼群島',
        areaCode: '+1345',
        countryCode: 'CYM',
        initial: 'kmqd',
        score: 0,
    },
    {
        id: 33,
        en: 'Central African Republic',
        zhCn: '中非共和国',
        zhTw: '中非共和國',
        areaCode: '+236',
        countryCode: 'CAF',
        initial: 'zfghg',
        score: 0,
    },
    {
        id: 34,
        en: 'Chad',
        zhCn: '乍得',
        zhTw: '乍得',
        areaCode: '+235',
        countryCode: 'TCD',
        initial: 'zd',
        score: 0,
    },
    {
        id: 35,
        en: 'Chile',
        zhCn: '智利',
        zhTw: '智利',
        areaCode: '+56',
        countryCode: 'CHL',
        initial: 'zl',
        score: 0,
    },
    {
        id: 36,
        en: 'China',
        zhCn: '中国内地',
        zhTw: '中國內地',
        areaCode: '+86',
        countryCode: 'CHN',
        initial: 'zgdl',
        score: 100,
    },
    {
        id: 37,
        en: 'Colombia',
        zhCn: '哥伦比亚',
        zhTw: '哥倫比亞',
        areaCode: '+57',
        countryCode: 'COL',
        initial: 'glby',
        score: 0,
    },
    {
        id: 38,
        en: 'Congo',
        zhCn: '刚果',
        zhTw: '剛果',
        areaCode: '+242',
        countryCode: 'COG',
        initial: 'gg',
        score: 0,
    },
    {
        id: 39,
        en: 'Cook Is.',
        zhCn: '库克群岛',
        zhTw: '庫克群島',
        areaCode: '+682',
        countryCode: 'COK',
        initial: 'kkqd',
        score: 0,
    },
    {
        id: 40,
        en: 'Costa Rica',
        zhCn: '哥斯达黎加',
        zhTw: '哥斯達黎加',
        areaCode: '+506',
        countryCode: 'CRI',
        initial: 'gsdlj',
        score: 0,
    },
    {
        id: 41,
        en: 'Cuba',
        zhCn: '古巴',
        zhTw: '古巴',
        areaCode: '+53',
        countryCode: 'CUB',
        initial: 'gb',
        score: 0,
    },
    {
        id: 42,
        en: 'Cyprus',
        zhCn: '塞浦路斯',
        zhTw: '塞浦路斯',
        areaCode: '+357',
        countryCode: 'CYP',
        initial: 'spls',
        score: 0,
    },
    {
        id: 43,
        en: 'Czech Republic',
        zhCn: '捷克共和国',
        zhTw: '捷克共和国',
        areaCode: '+420',
        countryCode: 'CZE',
        initial: 'jk',
        score: 0,
    },
    {
        id: 44,
        en: 'Denmark',
        zhCn: '丹麦',
        zhTw: '丹麥',
        areaCode: '+45',
        countryCode: 'DNK',
        initial: 'dm',
        score: 0,
    },
    {
        id: 45,
        en: 'Djibouti',
        zhCn: '吉布提',
        zhTw: '吉布提',
        areaCode: '+253',
        countryCode: 'DJI',
        initial: 'jbt',
        score: 0,
    },
    {
        id: 46,
        en: 'Dominica',
        zhCn: '多米尼克',
        zhTw: '多米尼克',
        areaCode: '+1767',
        countryCode: 'DMA',
        initial: 'dmnk',
        score: 0,
    },
    {
        id: 47,
        en: 'Ecuador',
        zhCn: '厄瓜多尔',
        zhTw: '厄瓜多爾',
        areaCode: '+593',
        countryCode: 'ECU',
        initial: 'egde',
        score: 0,
    },
    {
        id: 48,
        en: 'Egypt',
        zhCn: '埃及',
        zhTw: '埃及',
        areaCode: '+20',
        countryCode: 'EGY',
        initial: 'aj',
        score: 0,
    },
    {
        id: 49,
        en: 'EI Salvador',
        zhCn: '萨尔瓦多',
        zhTw: '薩爾瓦多',
        areaCode: '+503',
        countryCode: 'SLV',
        initial: 'sewd',
        score: 0,
    },
    {
        id: 50,
        en: 'Estonia',
        zhCn: '爱沙尼亚',
        zhTw: '愛沙尼亞',
        areaCode: '+372',
        countryCode: 'EST',
        initial: 'asny',
        score: 0,
    },
    {
        id: 51,
        en: 'Ethiopia',
        zhCn: '埃塞俄比亚',
        zhTw: '埃塞俄比亞',
        areaCode: '+251',
        countryCode: 'ETH',
        initial: 'aseby',
        score: 0,
    },
    {
        id: 52,
        en: 'Fiji',
        zhCn: '斐济',
        zhTw: '斐濟',
        areaCode: '+679',
        countryCode: 'FJI',
        initial: 'fj',
        score: 0,
    },
    {
        id: 53,
        en: 'Finland',
        zhCn: '芬兰',
        zhTw: '芬蘭',
        areaCode: '+358',
        countryCode: 'FIN',
        initial: 'fl',
        score: 0,
    },
    {
        id: 54,
        en: 'France',
        zhCn: '法国',
        zhTw: '法國',
        areaCode: '+33',
        countryCode: 'FRA',
        initial: 'fg',
        score: 0,
    },
    {
        id: 55,
        en: 'French Guiana',
        zhCn: '法属圭亚那',
        zhTw: '法屬圭亞那',
        areaCode: '+594',
        countryCode: 'GUF',
        initial: 'fsgyn',
        score: 0,
    },
    {
        id: 56,
        en: 'Gabon',
        zhCn: '加蓬',
        zhTw: '加蓬',
        areaCode: '+241',
        countryCode: 'GAB',
        initial: 'jp',
        score: 0,
    },
    {
        id: 57,
        en: 'Gambia',
        zhCn: '冈比亚',
        zhTw: '岡比亞',
        areaCode: '+220',
        countryCode: 'GMB',
        initial: 'gby',
        score: 0,
    },
    {
        id: 58,
        en: 'Georgia',
        zhCn: '格鲁吉亚',
        zhTw: '格魯吉亞',
        areaCode: '+995',
        countryCode: 'GEO',
        initial: 'gljy',
        score: 0,
    },
    {
        id: 59,
        en: 'Germany',
        zhCn: '德国',
        zhTw: '德國',
        areaCode: '+49',
        countryCode: 'DEU',
        initial: 'dg',
        score: 0,
    },
    {
        id: 60,
        en: 'Ghana',
        zhCn: '加纳',
        zhTw: '加納',
        areaCode: '+233',
        countryCode: 'GHA',
        initial: 'jn',
        score: 0,
    },
    {
        id: 61,
        en: 'Gibraltar',
        zhCn: '直布罗陀',
        zhTw: '直布羅陀',
        areaCode: '+350',
        countryCode: 'GIB',
        initial: 'zblt',
        score: 0,
    },
    {
        id: 62,
        en: 'Greece',
        zhCn: '希腊',
        zhTw: '希臘',
        areaCode: '+30',
        countryCode: 'GRC',
        initial: 'xl',
        score: 0,
    },
    {
        id: 63,
        en: 'Grenada',
        zhCn: '格林纳达',
        zhTw: '格林納達',
        areaCode: '+1809',
        countryCode: 'GRD',
        initial: 'glnd',
        score: 0,
    },
    {
        id: 64,
        en: 'Guam',
        zhCn: '关岛',
        zhTw: '關島',
        areaCode: '+1671',
        countryCode: 'GUM',
        initial: 'gd',
        score: 0,
    },
    {
        id: 65,
        en: 'Guatemala',
        zhCn: '危地马拉',
        zhTw: '危地馬拉',
        areaCode: '+502',
        countryCode: 'GTM',
        initial: 'wdml',
        score: 0,
    },
    {
        id: 66,
        en: 'Guinea',
        zhCn: '几内亚',
        zhTw: '幾內亞',
        areaCode: '+224',
        countryCode: 'GIN',
        initial: 'jny',
        score: 0,
    },
    {
        id: 67,
        en: 'Guyana',
        zhCn: '法属圭亚那',
        zhTw: '法属圭亚那',
        areaCode: '+592',
        countryCode: 'GUY',
        initial: 'gyn',
        score: 0,
    },
    {
        id: 68,
        en: 'Haiti',
        zhCn: '海地',
        zhTw: '海地',
        areaCode: '+509',
        countryCode: 'HTI',
        initial: 'hd',
        score: 0,
    },
    {
        id: 69,
        en: 'Honduras',
        zhCn: '洪都拉斯',
        zhTw: '洪都拉斯',
        areaCode: '+504',
        countryCode: 'HND',
        initial: 'hdls',
        score: 0,
    },
    {
        id: 70,
        en: 'Hongkong',
        zhCn: '中国香港',
        zhTw: '中國香港',
        areaCode: '+852',
        countryCode: 'HKG',
        initial: 'zgxg',
        score: 90,
    },
    {
        id: 71,
        en: 'Hungary',
        zhCn: '匈牙利',
        zhTw: '匈牙利',
        areaCode: '+36',
        countryCode: 'HUN',
        initial: 'xyl',
        score: 0,
    },
    {
        id: 72,
        en: 'Iceland',
        zhCn: '冰岛',
        zhTw: '冰島',
        areaCode: '+354',
        countryCode: 'ISL',
        initial: 'bd',
        score: 0,
    },
    {
        id: 73,
        en: 'India',
        zhCn: '印度',
        zhTw: '印度',
        areaCode: '+91',
        countryCode: 'IND',
        initial: 'yd',
        score: 0,
    },
    {
        id: 74,
        en: 'Indonesia',
        zhCn: '印度尼西亚',
        zhTw: '印度尼西亞',
        areaCode: '+62',
        countryCode: 'IDN',
        initial: 'ydnxy',
        score: 0,
    },
    {
        id: 75,
        en: 'Iran',
        zhCn: '伊朗伊斯兰共和国',
        zhTw: '伊朗伊斯蘭共和國',
        areaCode: '+98',
        countryCode: 'IRN',
        initial: 'yl',
        score: 0,
    },
    {
        id: 76,
        en: 'Iraq',
        zhCn: '伊拉克',
        zhTw: '伊拉克',
        areaCode: '+964',
        countryCode: 'IRQ',
        initial: 'ylk',
        score: 0,
    },
    {
        id: 77,
        en: 'Ireland',
        zhCn: '爱尔兰',
        zhTw: '愛爾蘭',
        areaCode: '+353',
        countryCode: 'IRL',
        initial: 'ael',
        score: 0,
    },
    {
        id: 78,
        en: 'Israel',
        zhCn: '以色列',
        zhTw: '以色列',
        areaCode: '+972',
        countryCode: 'ISR',
        initial: 'ysl',
        score: 0,
    },
    {
        id: 79,
        en: 'Italy',
        zhCn: '意大利',
        zhTw: '意大利',
        areaCode: '+39',
        countryCode: 'ITA',
        initial: 'ydl',
        score: 0,
    },
    {
        id: 80,
        en: 'Ivory Coast',
        zhCn: '科特迪瓦',
        zhTw: '科特迪瓦',
        areaCode: '+225',
        countryCode: 'CIV',
        initial: 'ktdw',
        score: 0,
    },
    {
        id: 81,
        en: 'Jamaica',
        zhCn: '牙买加',
        zhTw: '牙買加',
        areaCode: '+1876',
        countryCode: 'JAM',
        initial: 'ymj',
        score: 0,
    },
    {
        id: 82,
        en: 'Japan',
        zhCn: '日本',
        zhTw: '日本',
        areaCode: '+81',
        countryCode: 'JPN',
        initial: 'rb',
        score: 0,
    },
    {
        id: 83,
        en: 'Jordan',
        zhCn: '约旦',
        zhTw: '約旦',
        areaCode: '+962',
        countryCode: 'JOR',
        initial: 'yd',
        score: 0,
    },
    {
        id: 84,
        en: 'Kampuchea (Cambodia )',
        zhCn: '柬埔寨',
        zhTw: '柬埔寨',
        areaCode: '+855',
        countryCode: 'KHM',
        initial: 'jbz',
        score: 0,
    },
    {
        id: 85,
        en: 'Kazakstan',
        zhCn: '哈萨克斯坦',
        zhTw: '哈薩克斯坦',
        areaCode: '+327',
        countryCode: 'KAZ',
        initial: 'hskst',
        score: 0,
    },
    {
        id: 86,
        en: 'Kenya',
        zhCn: '肯尼亚',
        zhTw: '肯尼亞',
        areaCode: '+254',
        countryCode: 'KEN',
        initial: 'kny',
        score: 0,
    },
    {
        id: 87,
        en: 'Korea',
        zhCn: '韩国',
        zhTw: '韓國',
        areaCode: '+82',
        countryCode: 'KOR',
        initial: 'hg',
        score: 0,
    },
    {
        id: 88,
        en: 'Kuwait',
        zhCn: '科威特',
        zhTw: '科威特',
        areaCode: '+965',
        countryCode: 'KWT',
        initial: 'kwt',
        score: 0,
    },
    {
        id: 89,
        en: 'Kyrgyzstan',
        zhCn: '吉尔吉斯斯坦',
        zhTw: '吉爾吉斯斯坦',
        areaCode: '+331',
        countryCode: 'KGZ',
        initial: 'jejst',
        score: 0,
    },
    {
        id: 90,
        en: 'Laos',
        zhCn: '老挝',
        zhTw: '老撾',
        areaCode: '+856',
        countryCode: 'LAO',
        initial: 'lw',
        score: 0,
    },
    {
        id: 91,
        en: 'Latvia',
        zhCn: '拉脱维亚',
        zhTw: '拉脫維亞',
        areaCode: '+371',
        countryCode: 'LVA',
        initial: 'ltwy',
        score: 0,
    },
    {
        id: 92,
        en: 'Lebanon',
        zhCn: '黎巴嫩',
        zhTw: '黎巴嫩',
        areaCode: '+961',
        countryCode: 'LBN',
        initial: 'lbn',
        score: 0,
    },
    {
        id: 93,
        en: 'Lesotho',
        zhCn: '莱索托',
        zhTw: '萊索托',
        areaCode: '+266',
        countryCode: 'LSO',
        initial: 'lst',
        score: 0,
    },
    {
        id: 94,
        en: 'Liberia',
        zhCn: '利比里亚',
        zhTw: '利比里亞',
        areaCode: '+231',
        countryCode: 'LBR',
        initial: 'lbly',
        score: 0,
    },
    {
        id: 95,
        en: 'Libya',
        zhCn: '利比亚',
        zhTw: '利比亞',
        areaCode: '+218',
        countryCode: 'LBY',
        initial: 'lby',
        score: 0,
    },
    {
        id: 96,
        en: 'Liechtenstein',
        zhCn: '列支敦士登',
        zhTw: '列支敦士登',
        areaCode: '+423',
        countryCode: 'LIE',
        initial: 'lzdsd',
        score: 0,
    },
    {
        id: 97,
        en: 'Lithuania',
        zhCn: '立陶宛',
        zhTw: '立陶宛',
        areaCode: '+370',
        countryCode: 'LTU',
        initial: 'ltw',
        score: 0,
    },
    {
        id: 98,
        en: 'Luxembourg',
        zhCn: '卢森堡',
        zhTw: '盧森堡',
        areaCode: '+352',
        countryCode: 'LUX',
        initial: 'lsb',
        score: 0,
    },
    {
        id: 99,
        en: 'Macao',
        zhCn: '中国澳门',
        zhTw: '中國澳門',
        areaCode: '+853',
        countryCode: 'MAC',
        initial: 'zgam',
        score: 80,
    },
    {
        id: 100,
        en: 'Madagascar',
        zhCn: '马达加斯加',
        zhTw: '馬達加斯加',
        areaCode: '+261',
        countryCode: 'MDG',
        initial: 'mdjsj',
        score: 0,
    },
    {
        id: 101,
        en: 'Malawi',
        zhCn: '马拉维',
        zhTw: '馬拉維',
        areaCode: '+265',
        countryCode: 'MWI',
        initial: 'mlw',
        score: 0,
    },
    {
        id: 102,
        en: 'Malaysia',
        zhCn: '马来西亚',
        zhTw: '馬來西亞',
        areaCode: '+60',
        countryCode: 'MYS',
        initial: 'mlxy',
        score: 0,
    },
    {
        id: 103,
        en: 'Maldives',
        zhCn: '马尔代夫',
        zhTw: '馬爾代夫',
        areaCode: '+960',
        countryCode: 'MDV',
        initial: 'medf',
        score: 0,
    },
    {
        id: 104,
        en: 'Mali',
        zhCn: '马里',
        zhTw: '馬里',
        areaCode: '+223',
        countryCode: 'MLI',
        initial: 'ml',
        score: 0,
    },
    {
        id: 105,
        en: 'Malta',
        zhCn: '马耳他',
        zhTw: '馬耳他',
        areaCode: '+356',
        countryCode: 'MLT',
        initial: 'met',
        score: 0,
    },
    {
        id: 106,
        en: 'Mariana Is',
        zhCn: '北马里亚纳群岛',
        zhTw: '北馬里亞納群島',
        areaCode: '+1670',
        countryCode: 'MNP',
        initial: 'mlynqd',
        score: 0,
    },
    {
        id: 107,
        en: 'Martinique',
        zhCn: '马提尼克',
        zhTw: '馬提尼克',
        areaCode: '+596',
        countryCode: 'MTQ',
        initial: 'mtnk',
        score: 0,
    },
    {
        id: 108,
        en: 'Mauritius',
        zhCn: '毛里求斯',
        zhTw: '毛里求斯',
        areaCode: '+230',
        countryCode: 'MUS',
        initial: 'mlqs',
        score: 0,
    },
    {
        id: 109,
        en: 'Mexico',
        zhCn: '墨西哥',
        zhTw: '墨西哥',
        areaCode: '+52',
        countryCode: 'MEX',
        initial: 'mxg',
        score: 0,
    },
    {
        id: 110,
        en: 'Moldova, Republic of',
        zhCn: '摩尔多瓦共和国',
        zhTw: '摩爾多瓦共和國',
        areaCode: '+373',
        countryCode: 'MDA',
        initial: 'medw',
        score: 0,
    },
    {
        id: 111,
        en: 'Monaco',
        zhCn: '摩纳哥',
        zhTw: '摩納哥',
        areaCode: '+377',
        countryCode: 'MCO',
        initial: 'mng',
        score: 0,
    },
    {
        id: 112,
        en: 'Mongolia',
        zhCn: '蒙古',
        zhTw: '蒙古',
        areaCode: '+976',
        countryCode: 'MNG',
        initial: 'mg',
        score: 0,
    },
    {
        id: 113,
        en: 'Montserrat Is',
        zhCn: '蒙特塞拉特',
        zhTw: '蒙特塞拉特',
        areaCode: '+1664',
        countryCode: 'MSR',
        initial: 'mtsltd',
        score: 0,
    },
    {
        id: 114,
        en: 'Morocco',
        zhCn: '摩洛哥',
        zhTw: '摩洛哥',
        areaCode: '+212',
        countryCode: 'MAR',
        initial: 'mlg',
        score: 0,
    },
    {
        id: 115,
        en: 'Mozambique',
        zhCn: '莫桑比克',
        zhTw: '莫桑比克',
        areaCode: '+258',
        countryCode: 'MOZ',
        initial: 'msbk',
        score: 0,
    },
    {
        id: 116,
        en: 'Namibia',
        zhCn: '纳米比亚',
        zhTw: '納米比亞',
        areaCode: '+264',
        countryCode: 'NAM',
        initial: 'nmby',
        score: 0,
    },
    {
        id: 117,
        en: 'Nauru',
        zhCn: '瑙鲁',
        zhTw: '瑙魯',
        areaCode: '+674',
        countryCode: 'NRU',
        initial: 'nl',
        score: 0,
    },
    {
        id: 118,
        en: 'Nepal',
        zhCn: '尼泊尔',
        zhTw: '尼泊爾',
        areaCode: '+977',
        countryCode: 'NPL',
        initial: 'npe',
        score: 0,
    },
    {
        id: 119,
        en: 'Netherlands',
        zhCn: '荷兰',
        zhTw: '荷蘭',
        areaCode: '+31',
        countryCode: 'NLD',
        initial: 'hl',
        score: 0,
    },
    {
        id: 120,
        en: 'New Zealand',
        zhCn: '新西兰',
        zhTw: '新西蘭',
        areaCode: '+64',
        countryCode: 'NZL',
        initial: 'xxl',
        score: 0,
    },
    {
        id: 121,
        en: 'Nicaragua',
        zhCn: '尼加拉瓜',
        zhTw: '尼加拉瓜',
        areaCode: '+505',
        countryCode: 'NIC',
        initial: 'njlg',
        score: 0,
    },
    {
        id: 122,
        en: 'Niger',
        zhCn: '尼日尔',
        zhTw: '尼日爾',
        areaCode: '+227',
        countryCode: 'NER',
        initial: 'nre',
        score: 0,
    },
    {
        id: 123,
        en: 'Nigeria',
        zhCn: '尼日利亚',
        zhTw: '尼日利亞',
        areaCode: '+234',
        countryCode: 'NGA',
        initial: 'nrly',
        score: 0,
    },
    {
        id: 124,
        en: 'North Korea',
        zhCn: '朝鲜',
        zhTw: '朝鮮',
        areaCode: '+850',
        countryCode: 'PRK',
        initial: 'cx',
        score: 0,
    },
    {
        id: 125,
        en: 'Norway',
        zhCn: '挪威',
        zhTw: '挪威',
        areaCode: '+47',
        countryCode: 'NOR',
        initial: 'nw',
        score: 0,
    },
    {
        id: 126,
        en: 'Oman',
        zhCn: '阿曼',
        zhTw: '阿曼',
        areaCode: '+968',
        countryCode: 'OMN',
        initial: 'am',
        score: 0,
    },
    {
        id: 127,
        en: 'Pakistan',
        zhCn: '巴基斯坦',
        zhTw: '巴基斯坦',
        areaCode: '+92',
        countryCode: 'PAK',
        initial: 'bjst',
        score: 0,
    },
    {
        id: 128,
        en: 'Panama',
        zhCn: '巴拿马',
        zhTw: '巴拿馬',
        areaCode: '+507',
        countryCode: 'PAN',
        initial: 'bnm',
        score: 0,
    },
    {
        id: 129,
        en: 'Papua New Cuinea',
        zhCn: '巴布亚新几内亚',
        zhTw: '巴布亞新幾內亞',
        areaCode: '+675',
        countryCode: 'PNG',
        initial: 'bbyxjny',
        score: 0,
    },
    {
        id: 130,
        en: 'Paraguay',
        zhCn: '巴拉圭',
        zhTw: '巴拉圭',
        areaCode: '+595',
        countryCode: 'PRY',
        initial: 'blg',
        score: 0,
    },
    {
        id: 131,
        en: 'Peru',
        zhCn: '秘鲁',
        zhTw: '秘魯',
        areaCode: '+51',
        countryCode: 'PER',
        initial: 'ml',
        score: 0,
    },
    {
        id: 132,
        en: 'Philippines',
        zhCn: '菲律宾',
        zhTw: '菲律賓',
        areaCode: '+63',
        countryCode: 'PHL',
        initial: 'flb',
        score: 0,
    },
    {
        id: 133,
        en: 'Poland',
        zhCn: '波兰',
        zhTw: '波蘭',
        areaCode: '+48',
        countryCode: 'POL',
        initial: 'bl',
        score: 0,
    },
    {
        id: 134,
        en: 'French Polynesia',
        zhCn: '法属波利尼西亚',
        zhTw: '法属波利尼西亚',
        areaCode: '+689',
        countryCode: 'PYF',
        initial: 'fsblnxy',
        score: 0,
    },
    {
        id: 135,
        en: 'Portugal',
        zhCn: '葡萄牙',
        zhTw: '葡萄牙',
        areaCode: '+351',
        countryCode: 'PRT',
        initial: 'pty',
        score: 0,
    },
    {
        id: 136,
        en: 'Puerto Rico',
        zhCn: '波多黎各',
        zhTw: '波多黎各',
        areaCode: '+1787',
        countryCode: 'PRI',
        initial: 'bdlg',
        score: 0,
    },
    {
        id: 137,
        en: 'Qatar',
        zhCn: '卡塔尔',
        zhTw: '卡塔爾',
        areaCode: '+974',
        countryCode: 'QAT',
        initial: 'kte',
        score: 0,
    },
    {
        id: 138,
        en: 'Romania',
        zhCn: '罗马尼亚',
        zhTw: '羅馬尼亞',
        areaCode: '+40',
        countryCode: 'ROU',
        initial: 'lmny',
        score: 0,
    },
    {
        id: 139,
        en: 'Russia',
        zhCn: '俄罗斯',
        zhTw: '俄羅斯',
        areaCode: '+7',
        countryCode: 'RUS',
        initial: 'els',
        score: 0,
    },
    {
        id: 140,
        en: 'Samoa Eastern',
        zhCn: '美国萨摩亚',
        zhTw: '美國薩摩亞',
        areaCode: '+684',
        countryCode: 'ASM',
        initial: 'dsmy(m)',
        score: 0,
    },
    {
        id: 141,
        en: 'Samoa Western',
        zhCn: '萨摩亚',
        zhTw: '薩摩亞',
        areaCode: '+685',
        countryCode: 'WSM',
        initial: 'xsmy',
        score: 0,
    },
    {
        id: 142,
        en: 'San Marino',
        zhCn: '圣马力诺',
        zhTw: '聖馬力諾',
        areaCode: '+378',
        countryCode: 'SMR',
        initial: 'smln',
        score: 0,
    },
    {
        id: 143,
        en: 'Sao Tome and Principe',
        zhCn: '圣多美和普林西比',
        zhTw: '聖多美和普林西比',
        areaCode: '+239',
        countryCode: 'STP',
        initial: 'sdmhplxb',
        score: 0,
    },
    {
        id: 144,
        en: 'Saudi Arabia',
        zhCn: '沙特阿拉伯',
        zhTw: '沙特阿拉伯',
        areaCode: '+966',
        countryCode: 'SAU',
        initial: 'stelb',
        score: 0,
    },
    {
        id: 145,
        en: 'Senegal',
        zhCn: '塞内加尔',
        zhTw: '塞內加爾',
        areaCode: '+221',
        countryCode: 'SEN',
        initial: 'snje',
        score: 0,
    },
    {
        id: 146,
        en: 'Seychelles',
        zhCn: '塞舌尔',
        zhTw: '塞舌爾',
        areaCode: '+248',
        countryCode: 'SYC',
        initial: 'sse',
        score: 0,
    },
    {
        id: 147,
        en: 'Sierra Leone',
        zhCn: '塞拉利昂',
        zhTw: '塞拉利昂',
        areaCode: '+232',
        countryCode: 'SLE',
        initial: 'slla',
        score: 0,
    },
    {
        id: 148,
        en: 'Singapore',
        zhCn: '新加坡',
        zhTw: '新加坡',
        areaCode: '+65',
        countryCode: 'SGP',
        initial: 'xjp',
        score: 0,
    },
    {
        id: 149,
        en: 'Slovakia',
        zhCn: '斯洛伐克',
        zhTw: '斯洛伐克',
        areaCode: '+421',
        countryCode: 'SVK',
        initial: 'slfk',
        score: 0,
    },
    {
        id: 150,
        en: 'Slovenia',
        zhCn: '斯洛文尼亚',
        zhTw: '斯洛文尼亞',
        areaCode: '+386',
        countryCode: 'SVN',
        initial: 'slwny',
        score: 0,
    },
    {
        id: 151,
        en: 'Solomon Is',
        zhCn: '所罗门群岛',
        zhTw: '所羅門群島',
        areaCode: '+677',
        countryCode: 'SLB',
        initial: 'slmqd',
        score: 0,
    },
    {
        id: 152,
        en: 'Somali',
        zhCn: '索马里',
        zhTw: '索馬里',
        areaCode: '+252',
        countryCode: 'SOM',
        initial: 'sml',
        score: 0,
    },
    {
        id: 153,
        en: 'South Africa',
        zhCn: '南非',
        zhTw: '南非',
        areaCode: '+27',
        countryCode: 'ZAF',
        initial: 'nf',
        score: 0,
    },
    {
        id: 154,
        en: 'Spain',
        zhCn: '西班牙',
        zhTw: '西班牙',
        areaCode: '+34',
        countryCode: 'ESP',
        initial: 'xby',
        score: 0,
    },
    {
        id: 155,
        en: 'Sri Lanka',
        zhCn: '斯里兰卡',
        zhTw: '斯里蘭卡',
        areaCode: '+94',
        countryCode: 'LKA',
        initial: 'sllk',
        score: 0,
    },
    {
        id: 156,
        en: 'St.Lucia',
        zhCn: '圣卢西亚',
        zhTw: '聖盧西亞',
        areaCode: '+1758',
        countryCode: 'LCA',
        initial: 'slxy',
        score: 0,
    },
    {
        id: 157,
        en: 'St.Vincent',
        zhCn: '圣文森特',
        zhTw: '聖文森特',
        areaCode: '+1784',
        countryCode: 'VCT',
        initial: 'swst',
        score: 0,
    },
    {
        id: 158,
        en: 'Sudan',
        zhCn: '苏丹',
        zhTw: '蘇丹',
        areaCode: '+249',
        countryCode: 'SDN',
        initial: 'sd',
        score: 0,
    },
    {
        id: 159,
        en: 'Suriname',
        zhCn: '苏里南',
        zhTw: '蘇里南',
        areaCode: '+597',
        countryCode: 'SUR',
        initial: 'sln',
        score: 0,
    },
    {
        id: 160,
        en: 'Swaziland',
        zhCn: '斯威士兰',
        zhTw: '斯威士蘭',
        areaCode: '+268',
        countryCode: 'SWZ',
        initial: 'swsl',
        score: 0,
    },
    {
        id: 161,
        en: 'Sweden',
        zhCn: '瑞典',
        zhTw: '瑞典',
        areaCode: '+46',
        countryCode: 'SWE',
        initial: 'rd',
        score: 0,
    },
    {
        id: 162,
        en: 'Switzerland',
        zhCn: '瑞士',
        zhTw: '瑞士',
        areaCode: '+41',
        countryCode: 'CHE',
        initial: 'rs',
        score: 0,
    },
    {
        id: 163,
        en: 'Syria',
        zhCn: '叙利亚',
        zhTw: '敘利亞',
        areaCode: '+963',
        countryCode: 'SYR',
        initial: 'xly',
        score: 0,
    },
    {
        id: 164,
        en: 'Taiwan',
        zhCn: '中国台湾',
        zhTw: '中國台灣',
        areaCode: '+886',
        countryCode: 'TWN',
        initial: 'zgtw',
        score: 70,
    },
    {
        id: 165,
        en: 'Tajikstan',
        zhCn: '塔吉克斯坦',
        zhTw: '塔吉克斯坦',
        areaCode: '+992',
        countryCode: 'TJK',
        initial: 'tjkst',
        score: 0,
    },
    {
        id: 166,
        en: 'Tanzania',
        zhCn: '坦桑尼亚',
        zhTw: '坦桑尼亞',
        areaCode: '+255',
        countryCode: 'TZA',
        initial: 'tsny',
        score: 0,
    },
    {
        id: 167,
        en: 'Thailand',
        zhCn: '泰国',
        zhTw: '泰國',
        areaCode: '+66',
        countryCode: 'THA',
        initial: 'tg',
        score: 0,
    },
    {
        id: 168,
        en: 'Togo',
        zhCn: '多哥',
        zhTw: '多哥',
        areaCode: '+228',
        countryCode: 'TGO',
        initial: 'dg',
        score: 0,
    },
    {
        id: 169,
        en: 'Tonga',
        zhCn: '汤加',
        zhTw: '湯加',
        areaCode: '+676',
        countryCode: 'TON',
        initial: 'tj',
        score: 0,
    },
    {
        id: 170,
        en: 'Trinidad and Tobago',
        zhCn: '特立尼达和多巴哥',
        zhTw: '特立尼達和多巴哥',
        areaCode: '+1809',
        countryCode: 'TTO',
        initial: 'tlndhdbg',
        score: 0,
    },
    {
        id: 171,
        en: 'Tunisia',
        zhCn: '突尼斯',
        zhTw: '突尼斯',
        areaCode: '+216',
        countryCode: 'TUN',
        initial: 'tns',
        score: 0,
    },
    {
        id: 172,
        en: 'Turkey',
        zhCn: '土耳其',
        zhTw: '土耳其',
        areaCode: '+90',
        countryCode: 'TUR',
        initial: 'teq',
        score: 0,
    },
    {
        id: 173,
        en: 'Turkmenistan',
        zhCn: '土库曼斯坦',
        zhTw: '土庫曼斯坦',
        areaCode: '+993',
        countryCode: 'TKM',
        initial: 'tkmst',
        score: 0,
    },
    {
        id: 174,
        en: 'Uganda',
        zhCn: '乌干达',
        zhTw: '烏干達',
        areaCode: '+256',
        countryCode: 'UGA',
        initial: 'wgd',
        score: 0,
    },
    {
        id: 175,
        en: 'Ukraine',
        zhCn: '乌克兰',
        zhTw: '烏克蘭',
        areaCode: '+380',
        countryCode: 'UKR',
        initial: 'wkl',
        score: 0,
    },
    {
        id: 176,
        en: 'United Arab Emirates',
        zhCn: '阿拉伯联合酋长国',
        zhTw: '阿拉伯聯合酋長國',
        areaCode: '+971',
        countryCode: 'ARE',
        initial: 'elblhqcg',
        score: 0,
    },
    {
        id: 177,
        en: 'United Kingdom',
        zhCn: '英国',
        zhTw: '英國',
        areaCode: '+44',
        countryCode: 'GBR',
        initial: 'yg',
        score: 0,
    },
    {
        id: 178,
        en: 'United States of America',
        zhCn: '美国',
        zhTw: '美國',
        areaCode: '+1',
        countryCode: 'USA',
        initial: 'mg',
        score: 60,
    },
    {
        id: 179,
        en: 'Uruguay',
        zhCn: '乌拉圭',
        zhTw: '烏拉圭',
        areaCode: '+598',
        countryCode: 'URY',
        initial: 'wlg',
        score: 0,
    },
    {
        id: 180,
        en: 'Uzbekistan',
        zhCn: '乌兹别克斯坦',
        zhTw: '烏茲別克斯坦',
        areaCode: '+233',
        countryCode: 'UZB',
        initial: 'wcbkst',
        score: 0,
    },
    {
        id: 181,
        en: 'Venezuela',
        zhCn: '委内瑞拉',
        zhTw: '委內瑞拉',
        areaCode: '+58',
        countryCode: 'VEN',
        initial: 'wnrl',
        score: 0,
    },
    {
        id: 182,
        en: 'Vietnam',
        zhCn: '越南',
        zhTw: '越南',
        areaCode: '+84',
        countryCode: 'VNM',
        initial: 'yn',
        score: 0,
    },
    {
        id: 183,
        en: 'Yemen',
        zhCn: '也门',
        zhTw: '也門',
        areaCode: '+967',
        countryCode: 'YEM',
        initial: 'ym',
        score: 0,
    },
    {
        id: 184,
        en: 'Zimbabwe',
        zhCn: '津巴布韦',
        zhTw: '津巴布韋',
        areaCode: '+263',
        countryCode: 'ZWE',
        initial: 'jbbw',
        score: 0,
    },
    {
        id: 185,
        en: 'Zambia',
        zhCn: '赞比亚',
        zhTw: '贊比亞',
        areaCode: '+260',
        countryCode: 'ZMB',
        initial: 'zby',
        score: 0,
    },
    {
        id: 186,
        en: 'Vanuatu',
        zhCn: '瓦努阿图',
        zhTw: '瓦努阿圖',
        areaCode: '+678',
        countryCode: 'VUT',
        initial: 'wnat',
        score: 0,
    },
    {
        id: 187,
        en: 'Palau',
        zhCn: '帕劳',
        zhTw: '帕勞',
        areaCode: '+680',
        countryCode: 'PLW',
        initial: 'pl',
        score: 0,
    },
    {
        id: 188,
        en: 'Marshall Islands',
        zhCn: '马绍尔群岛',
        zhTw: '馬紹爾群島',
        areaCode: '+692',
        countryCode: 'MHL',
        initial: 'mseqd',
        score: 0,
    },
    {
        id: 189,
        en: 'Saint Kitts and Nevis',
        zhCn: '圣基茨和尼维斯',
        zhTw: '聖基茨和尼維斯',
        areaCode: '+1869',
        countryCode: 'KNA',
        initial: 'sjchnws',
        score: 0,
    },
    {
        id: 190,
        en: 'Bhutan',
        zhCn: '不丹',
        zhTw: '不丹',
        areaCode: '+975',
        countryCode: 'BTN',
        initial: 'bd',
        score: 0,
    },
    {
        id: 191,
        en: 'Cape Verde',
        zhCn: '佛得角',
        zhTw: '佛得角',
        areaCode: '+238',
        countryCode: 'CPV',
        initial: 'fdj',
        score: 0,
    },
    {
        id: 192,
        en: 'Comoros',
        zhCn: '科摩罗',
        zhTw: '科摩羅',
        areaCode: '+269',
        countryCode: 'COM',
        initial: 'kml',
        score: 0,
    },
    {
        id: 193,
        en: 'Croatia',
        zhCn: '克罗地亚',
        zhTw: '克羅地亞',
        areaCode: '+385',
        countryCode: 'HRV',
        initial: 'klyy',
        score: 0,
    },
    {
        id: 194,
        en: 'Dominican Republic',
        zhCn: '多米尼加共和国',
        zhTw: '多米尼加共和國',
        areaCode: '+1809',
        countryCode: 'DOM',
        initial: 'dmnjghg',
        score: 0,
    },
    {
        id: 195,
        en: 'Equatorial Guinea',
        zhCn: '赤道几内亚',
        zhTw: '赤道幾內亞',
        areaCode: '+240',
        countryCode: 'GNQ',
        initial: 'cdjny',
        score: 0,
    },
    {
        id: 196,
        en: 'Guyana',
        zhCn: '圭亚那',
        zhTw: '圭亞那',
        areaCode: '+592',
        countryCode: 'GUY',
        initial: 'gyn',
        score: 0,
    },
    {
        id: 197,
        en: 'Kiribati',
        zhCn: '基里巴斯',
        zhTw: '基里巴斯',
        areaCode: '+686',
        countryCode: 'KIR',
        initial: 'jlbs',
        score: 0,
    },
    {
        id: 198,
        en: 'Mauritania',
        zhCn: '毛里塔尼亚',
        zhTw: '毛里塔尼亞',
        areaCode: '+222',
        countryCode: 'MRT',
        initial: 'mltny',
        score: 0,
    },
    {
        id: 199,
        en: 'Micronesia',
        zhCn: '密克罗尼西亚联邦',
        zhTw: '密克羅尼西亞聯邦',
        areaCode: '+691',
        countryCode: 'FSM',
        initial: 'mklnsylb',
        score: 0,
    },
    {
        id: 200,
        en: 'North Macedonia',
        zhCn: '北马其顿',
        zhTw: '北馬其頓',
        areaCode: '+389',
        countryCode: 'MKD',
        initial: 'bmqd',
        score: 0,
    },
    {
        id: 201,
        en: 'Timor-Leste',
        zhCn: '东帝汶',
        zhTw: '東帝汶',
        areaCode: '+670',
        countryCode: 'TLS',
        initial: 'ddw',
        score: 0,
    },
    {
        id: 202,
        en: 'Tuvalu',
        zhCn: '图瓦卢',
        zhTw: '圖瓦盧',
        areaCode: '+688',
        countryCode: 'TUV',
        initial: 'twl',
        score: 0,
    },
    {
        id: 203,
        en: 'Vatican City',
        zhCn: '梵蒂冈',
        zhTw: '梵蒂岡',
        areaCode: '+379',
        countryCode: 'VAT',
        initial: 'fdg',
        score: 0,
    },
    {
        id: 204,
        en: 'Palestine',
        zhCn: '巴勒斯坦',
        zhTw: '巴勒斯坦國',
        areaCode: '+970',
        countryCode: 'PSE',
        initial: 'blst',
        score: 0,
    },
    {
        id: 205,
        en: 'Niue',
        zhCn: '纽埃',
        zhTw: '紐埃',
        areaCode: '+683',
        countryCode: 'NIU',
        initial: 'na',
        score: 0,
    },
]
export const countrysInfo = [
        {
            id: 1,
            en: "Angola",
            zhCn: "安哥拉",
            zhTw: "安哥拉",
            areaCode: "+244",
            countryCode: "AGO",
            initial: "agl",
            score: 0,
            countryCode2: "AO"
        },
        {
            id: 2,
            en: "Afghanistan",
            zhCn: "阿富汗",
            zhTw: "阿富汗",
            areaCode: "+93",
            countryCode: "AFG",
            initial: "efh",
            score: 0,
            countryCode2: "AF"
        },
        {
            id: 3,
            en: "Albania",
            zhCn: "阿尔巴尼亚",
            zhTw: "阿爾巴尼亞",
            areaCode: "+355",
            countryCode: "ALB",
            initial: "eebny",
            score: 0,
            countryCode2: "AL"
        },
        {
            id: 4,
            en: "Algeria",
            zhCn: "阿尔及利亚",
            zhTw: "阿爾及利亞",
            areaCode: "+213",
            countryCode: "DZA",
            initial: "eejly",
            score: 0,
            countryCode2: "DZ"
        },
        {
            id: 5,
            en: "Andorra",
            zhCn: "安道尔共和国",
            zhTw: "安道爾共和國",
            areaCode: "+376",
            countryCode: "AND",
            initial: "adeghg",
            score: 0,
            countryCode2: "AD"
        },
        {
            id: 6,
            en: "Anguilla",
            zhCn: "安圭拉岛",
            zhTw: "安圭拉島",
            areaCode: "+1264",
            countryCode: "AIA",
            initial: "agld",
            score: 0,
            countryCode2: "AI"
        },
        {
            id: 7,
            en: "Antigua and Barbuda",
            zhCn: "安提瓜和巴布达",
            zhTw: "安提瓜和巴布達",
            areaCode: "+1268",
            countryCode: "ATG",
            initial: "atghbbd",
            score: 0,
            countryCode2: "AG"
        },
        {
            id: 8,
            en: "Argentina",
            zhCn: "阿根廷",
            zhTw: "阿根廷",
            areaCode: "+54",
            countryCode: "ARG",
            initial: "egt",
            score: 0,
            countryCode2: "AR"
        },
        {
            id: 9,
            en: "Armenia",
            zhCn: "亚美尼亚",
            zhTw: "亞美尼亞",
            areaCode: "+374",
            countryCode: "ARM",
            initial: "ymny",
            score: 0,
            countryCode2: "AM"
        },
        {
            id: 10,
            en: "Australia",
            zhCn: "澳大利亚",
            zhTw: "澳大利亞",
            areaCode: "+61",
            countryCode: "AUS",
            initial: "adly",
            score: 0,
            countryCode2: "AU"
        },
        {
            id: 11,
            en: "Austria",
            zhCn: "奥地利",
            zhTw: "奧地利",
            areaCode: "+43",
            countryCode: "AUT",
            initial: "adl",
            score: 0,
            countryCode2: "AT"
        },
        {
            id: 12,
            en: "Azerbaijan",
            zhCn: "阿塞拜疆",
            zhTw: "阿塞拜疆",
            areaCode: "+994",
            countryCode: "AZE",
            initial: "esbj",
            score: 0,
            countryCode2: "AZ"
        },
        {
            id: 13,
            en: "Bahamas",
            zhCn: "巴哈马",
            zhTw: "巴哈馬",
            areaCode: "+1242",
            countryCode: "BHS",
            initial: "bhm",
            score: 0,
            countryCode2: "BS"
        },
        {
            id: 14,
            en: "Bahrain",
            zhCn: "巴林",
            zhTw: "巴林",
            areaCode: "+973",
            countryCode: "BHR",
            initial: "bl",
            score: 0,
            countryCode2: "BH"
        },
        {
            id: 15,
            en: "Bangladesh",
            zhCn: "孟加拉国",
            zhTw: "孟加拉國",
            areaCode: "+880",
            countryCode: "BGD",
            initial: "mjlg",
            score: 0,
            countryCode2: "BD"
        },
        {
            id: 16,
            en: "Barbados",
            zhCn: "巴巴多斯",
            zhTw: "巴巴多斯",
            areaCode: "+1246",
            countryCode: "BRB",
            initial: "bbds",
            score: 0,
            countryCode2: "BB"
        },
        {
            id: 17,
            en: "Belarus",
            zhCn: "白俄罗斯",
            zhTw: "白俄羅斯",
            areaCode: "+375",
            countryCode: "BLR",
            initial: "bels",
            score: 0,
            countryCode2: "BY"
        },
        {
            id: 18,
            en: "Belgium",
            zhCn: "比利时",
            zhTw: "比利時",
            areaCode: "+32",
            countryCode: "BEL",
            initial: "bls",
            score: 0,
            countryCode2: "BE"
        },
        {
            id: 19,
            en: "Belize",
            zhCn: "伯利兹",
            zhTw: "伯利茲",
            areaCode: "+501",
            countryCode: "BLZ",
            initial: "blc",
            score: 0,
            countryCode2: "BZ"
        },
        {
            id: 20,
            en: "Benin",
            zhCn: "贝宁",
            zhTw: "貝寧",
            areaCode: "+229",
            countryCode: "BEN",
            initial: "bn",
            score: 0,
            countryCode2: "BJ"
        },
        {
            id: 21,
            en: "Bermuda Is.",
            zhCn: "百慕大群岛",
            zhTw: "百慕大群島",
            areaCode: "+1441",
            countryCode: "BMU",
            initial: "bmdqd",
            score: 0,
            countryCode2: "BM"
        },
        {
            id: 22,
            en: "Bolivia",
            zhCn: "玻利维亚",
            zhTw: "玻利維亞",
            areaCode: "+591",
            countryCode: "BOL",
            initial: "blwy",
            score: 0,
            countryCode2: "BO"
        },
        {
            id: 23,
            en: "Botswana",
            zhCn: "博茨瓦纳",
            zhTw: "博茨瓦納",
            areaCode: "+267",
            countryCode: "BWA",
            initial: "bcwn",
            score: 0,
            countryCode2: "BW"
        },
        {
            id: 24,
            en: "Brazil",
            zhCn: "巴西",
            zhTw: "巴西",
            areaCode: "+55",
            countryCode: "BRA",
            initial: "bx",
            score: 0,
            countryCode2: "BR"
        },
        {
            id: 25,
            en: "Brunei",
            zhCn: "文莱",
            zhTw: "文萊",
            areaCode: "+673",
            countryCode: "BRN",
            initial: "wl",
            score: 0,
            countryCode2: "BN"
        },
        {
            id: 26,
            en: "Bulgaria",
            zhCn: "保加利亚",
            zhTw: "保加利亞",
            areaCode: "+359",
            countryCode: "BGR",
            initial: "bjly",
            score: 0,
            countryCode2: "BG"
        },
        {
            id: 27,
            en: "Burkinafaso",
            zhCn: "布基纳法索",
            zhTw: "布基納法索",
            areaCode: "+226",
            countryCode: "BFA",
            initial: "bjnfs",
            score: 0,
            countryCode2: "BF"
        },
        {
            id: 28,
            en: "Burma",
            zhCn: "缅甸",
            zhTw: "緬甸",
            areaCode: "+95",
            countryCode: "MMR",
            initial: "md",
            score: 0,
            countryCode2: "MM"
        },
        {
            id: 29,
            en: "Burundi",
            zhCn: "布隆迪",
            zhTw: "布隆迪",
            areaCode: "+257",
            countryCode: "BDI",
            initial: "bld",
            score: 0,
            countryCode2: "BI"
        },
        {
            id: 30,
            en: "Cameroon",
            zhCn: "喀麦隆",
            zhTw: "喀麥隆",
            areaCode: "+237",
            countryCode: "CMR",
            initial: "kml",
            score: 0,
            countryCode2: "CM"
        },
        {
            id: 31,
            en: "Canada",
            zhCn: "加拿大",
            zhTw: "加拿大",
            areaCode: "+1",
            countryCode: "CAN",
            initial: "jnd",
            score: 0,
            countryCode2: "CA"
        },
        {
            id: 32,
            en: "Cayman Is.",
            zhCn: "开曼群岛",
            zhTw: "開曼群島",
            areaCode: "+1345",
            countryCode: "CYM",
            initial: "kmqd",
            score: 0,
            countryCode2: "KY"
        },
        {
            id: 33,
            en: "Central African Republic",
            zhCn: "中非共和国",
            zhTw: "中非共和國",
            areaCode: "+236",
            countryCode: "CAF",
            initial: "zfghg",
            score: 0,
            countryCode2: "CF"
        },
        {
            id: 34,
            en: "Chad",
            zhCn: "乍得",
            zhTw: "乍得",
            areaCode: "+235",
            countryCode: "TCD",
            initial: "zd",
            score: 0,
            countryCode2: "TD"
        },
        {
            id: 35,
            en: "Chile",
            zhCn: "智利",
            zhTw: "智利",
            areaCode: "+56",
            countryCode: "CHL",
            initial: "zl",
            score: 0,
            countryCode2: "CL"
        },
        {
            id: 36,
            en: "China",
            zhCn: "中国内地",
            zhTw: "中國内地",
            areaCode: "+86",
            countryCode: "CHN",
            initial: "zgdl",
            score: 100,
            countryCode2: "CN"
        },
        {
            id: 37,
            en: "Colombia",
            zhCn: "哥伦比亚",
            zhTw: "哥倫比亞",
            areaCode: "+57",
            countryCode: "COL",
            initial: "glby",
            score: 0,
            countryCode2: "CO"
        },
        {
            id: 38,
            en: "Congo",
            zhCn: "刚果",
            zhTw: "剛果",
            areaCode: "+242",
            countryCode: "COG",
            initial: "gg",
            score: 0,
            countryCode2: "CG"
        },
        {
            id: 39,
            en: "Cook Is.",
            zhCn: "库克群岛",
            zhTw: "庫克群島",
            areaCode: "+682",
            countryCode: "COK",
            initial: "kkqd",
            score: 0,
            countryCode2: "CK"
        },
        {
            id: 40,
            en: "Costa Rica",
            zhCn: "哥斯达黎加",
            zhTw: "哥斯達黎加",
            areaCode: "+506",
            countryCode: "CRI",
            initial: "gsdlj",
            score: 0,
            countryCode2: "CR"
        },
        {
            id: 41,
            en: "Cuba",
            zhCn: "古巴",
            zhTw: "古巴",
            areaCode: "+53",
            countryCode: "CUB",
            initial: "gb",
            score: 0,
            countryCode2: "CU"
        },
        {
            id: 42,
            en: "Cyprus",
            zhCn: "塞浦路斯",
            zhTw: "塞浦路斯",
            areaCode: "+357",
            countryCode: "CYP",
            initial: "spls",
            score: 0,
            countryCode2: "CY"
        },
        {
            id: 43,
            en: "Czech Republic",
            zhCn: "捷克",
            zhTw: "捷克",
            areaCode: "+420",
            countryCode: "CZE",
            initial: "jk",
            score: 0,
            countryCode2: "CZ"
        },
        {
            id: 44,
            en: "Denmark",
            zhCn: "丹麦",
            zhTw: "丹麥",
            areaCode: "+45",
            countryCode: "DNK",
            initial: "dm",
            score: 0,
            countryCode2: "DK"
        },
        {
            id: 45,
            en: "Djibouti",
            zhCn: "吉布提",
            zhTw: "吉布提",
            areaCode: "+253",
            countryCode: "DJI",
            initial: "jbt",
            score: 0,
            countryCode2: "DJ"
        },
        {
            id: 46,
            en: "Dominica Rep.",
            zhCn: "多米尼克",
            zhTw: "多米尼克",
            areaCode: "+1767",
            countryCode: "DMA",
            initial: "dmnk",
            score: 0,
            countryCode2: "DM"
        },
        {
            id: 47,
            en: "Ecuador",
            zhCn: "厄瓜多尔",
            zhTw: "厄瓜多爾",
            areaCode: "+593",
            countryCode: "ECU",
            initial: "egde",
            score: 0,
            countryCode2: "EC"
        },
        {
            id: 48,
            en: "Egypt",
            zhCn: "埃及",
            zhTw: "埃及",
            areaCode: "+20",
            countryCode: "EGY",
            initial: "aj",
            score: 0,
            countryCode2: "EG"
        },
        {
            id: 49,
            en: "EI Salvador",
            zhCn: "萨尔瓦多",
            zhTw: "薩爾瓦多",
            areaCode: "+503",
            countryCode: "SLV",
            initial: "sewd",
            score: 0,
            countryCode2: "SV"
        },
        {
            id: 50,
            en: "Estonia",
            zhCn: "爱沙尼亚",
            zhTw: "愛沙尼亞",
            areaCode: "+372",
            countryCode: "EST",
            initial: "asny",
            score: 0,
            countryCode2: "EE"
        },
        {
            id: 51,
            en: "Ethiopia",
            zhCn: "埃塞俄比亚",
            zhTw: "埃塞俄比亞",
            areaCode: "+251",
            countryCode: "ETH",
            initial: "aseby",
            score: 0,
            countryCode2: "ET"
        },
        {
            id: 52,
            en: "Fiji",
            zhCn: "斐济",
            zhTw: "斐濟",
            areaCode: "+679",
            countryCode: "FJI",
            initial: "fj",
            score: 0,
            countryCode2: "FJ"
        },
        {
            id: 53,
            en: "Finland",
            zhCn: "芬兰",
            zhTw: "芬蘭",
            areaCode: "+358",
            countryCode: "FIN",
            initial: "fl",
            score: 0,
            countryCode2: "FI"
        },
        {
            id: 54,
            en: "France",
            zhCn: "法国",
            zhTw: "法國",
            areaCode: "+33",
            countryCode: "FRA",
            initial: "fg",
            score: 0,
            countryCode2: "FR"
        },
        {
            id: 55,
            en: "French Guiana",
            zhCn: "法属圭亚那",
            zhTw: "法屬圭亞那",
            areaCode: "+594",
            countryCode: "GUF",
            initial: "fsgyn",
            score: 0,
            countryCode2: "GF"
        },
        {
            id: 56,
            en: "Gabon",
            zhCn: "加蓬",
            zhTw: "加蓬",
            areaCode: "+241",
            countryCode: "GAB",
            initial: "jp",
            score: 0,
            countryCode2: "GA"
        },
        {
            id: 57,
            en: "Gambia",
            zhCn: "冈比亚",
            zhTw: "岡比亞",
            areaCode: "+220",
            countryCode: "GMB",
            initial: "gby",
            score: 0,
            countryCode2: "GM"
        },
        {
            id: 58,
            en: "Georgia",
            zhCn: "格鲁吉亚",
            zhTw: "格魯吉亞",
            areaCode: "+995",
            countryCode: "GEO",
            initial: "gljy",
            score: 0,
            countryCode2: "GE"
        },
        {
            id: 59,
            en: "Germany",
            zhCn: "德国",
            zhTw: "德國",
            areaCode: "+49",
            countryCode: "DEU",
            initial: "dg",
            score: 0,
            countryCode2: "DE"
        },
        {
            id: 60,
            en: "Ghana",
            zhCn: "加纳",
            zhTw: "加納",
            areaCode: "+233",
            countryCode: "GHA",
            initial: "jn",
            score: 0,
            countryCode2: "GH"
        },
        {
            id: 61,
            en: "Gibraltar",
            zhCn: "直布罗陀",
            zhTw: "直布羅陀",
            areaCode: "+350",
            countryCode: "GIB",
            initial: "zblt",
            score: 0,
            countryCode2: "GI"
        },
        {
            id: 62,
            en: "Greece",
            zhCn: "希腊",
            zhTw: "希臘",
            areaCode: "+30",
            countryCode: "GRC",
            initial: "xl",
            score: 0,
            countryCode2: "GR"
        },
        {
            id: 63,
            en: "Grenada",
            zhCn: "格林纳达",
            zhTw: "格林納達",
            areaCode: "+1809",
            countryCode: "GRD",
            initial: "glnd",
            score: 0,
            countryCode2: "GD"
        },
        {
            id: 64,
            en: "Guam",
            zhCn: "关岛",
            zhTw: "關島",
            areaCode: "+1671",
            countryCode: "GUM",
            initial: "gd",
            score: 0,
            countryCode2: "GU"
        },
        {
            id: 65,
            en: "Guatemala",
            zhCn: "危地马拉",
            zhTw: "危地馬拉",
            areaCode: "+502",
            countryCode: "GTM",
            initial: "wdml",
            score: 0,
            countryCode2: "GT"
        },
        {
            id: 66,
            en: "Guinea",
            zhCn: "几内亚",
            zhTw: "幾內亞",
            areaCode: "+224",
            countryCode: "GIN",
            initial: "jny",
            score: 0,
            countryCode2: "GN"
        },
        {
            id: 67,
            en: "Guyana",
            zhCn: "圭亚那",
            zhTw: "圭亞那",
            areaCode: "+592",
            countryCode: "GUY",
            initial: "gyn",
            score: 0,
            countryCode2: "GY"
        },
        {
            id: 68,
            en: "Haiti",
            zhCn: "海地",
            zhTw: "海地",
            areaCode: "+509",
            countryCode: "HTI",
            initial: "hd",
            score: 0,
            countryCode2: "HT"
        },
        {
            id: 69,
            en: "Honduras",
            zhCn: "洪都拉斯",
            zhTw: "洪都拉斯",
            areaCode: "+504",
            countryCode: "HND",
            initial: "hdls",
            score: 0,
            countryCode2: "HN"
        },
        {
            id: 70,
            en: "Hong Kong",
            zhCn: "中国香港",
            zhTw: "中國香港",
            areaCode: "+852",
            countryCode: "HKG",
            initial: "zgxg",
            score: 90,
            countryCode2: "HK"
        },
        {
            id: 71,
            en: "Hungary",
            zhCn: "匈牙利",
            zhTw: "匈牙利",
            areaCode: "+36",
            countryCode: "HUN",
            initial: "xyl",
            score: 0,
            countryCode2: "HU"
        },
        {
            id: 72,
            en: "Iceland",
            zhCn: "冰岛",
            zhTw: "冰島",
            areaCode: "+354",
            countryCode: "ISL",
            initial: "bd",
            score: 0,
            countryCode2: "IS"
        },
        {
            id: 73,
            en: "India",
            zhCn: "印度",
            zhTw: "印度",
            areaCode: "+91",
            countryCode: "IND",
            initial: "yd",
            score: 0,
            countryCode2: "IN"
        },
        {
            id: 74,
            en: "Indonesia",
            zhCn: "印度尼西亚",
            zhTw: "印度尼西亞",
            areaCode: "+62",
            countryCode: "IDN",
            initial: "ydnxy",
            score: 0,
            countryCode2: "ID"
        },
        {
            id: 75,
            en: "Iran",
            zhCn: "伊朗",
            zhTw: "伊朗",
            areaCode: "+98",
            countryCode: "IRN",
            initial: "yl",
            score: 0,
            countryCode2: "IR"
        },
        {
            id: 76,
            en: "Iraq",
            zhCn: "伊拉克",
            zhTw: "伊拉克",
            areaCode: "+964",
            countryCode: "IRQ",
            initial: "ylk",
            score: 0,
            countryCode2: "IQ"
        },
        {
            id: 77,
            en: "Ireland",
            zhCn: "爱尔兰",
            zhTw: "愛爾蘭",
            areaCode: "+353",
            countryCode: "IRL",
            initial: "ael",
            score: 0,
            countryCode2: "IE"
        },
        {
            id: 78,
            en: "Israel",
            zhCn: "以色列",
            zhTw: "以色列",
            areaCode: "+972",
            countryCode: "ISR",
            initial: "ysl",
            score: 0,
            countryCode2: "IL"
        },
        {
            id: 79,
            en: "Italy",
            zhCn: "意大利",
            zhTw: "意大利",
            areaCode: "+39",
            countryCode: "ITA",
            initial: "ydl",
            score: 0,
            countryCode2: "IT"
        },
        {
            id: 80,
            en: "Ivory Coast",
            zhCn: "科特迪瓦",
            zhTw: "科特迪瓦",
            areaCode: "+225",
            countryCode: "CIV",
            initial: "ktdw",
            score: 0,
            countryCode2: "CI"
        },
        {
            id: 81,
            en: "Jamaica",
            zhCn: "牙买加",
            zhTw: "牙買加",
            areaCode: "+1876",
            countryCode: "JAM",
            initial: "ymj",
            score: 0,
            countryCode2: "JM"
        },
        {
            id: 82,
            en: "Japan",
            zhCn: "日本",
            zhTw: "日本",
            areaCode: "+81",
            countryCode: "JPN",
            initial: "rb",
            score: 0,
            countryCode2: "JP"
        },
        {
            id: 83,
            en: "Jordan",
            zhCn: "约旦",
            zhTw: "約旦",
            areaCode: "+962",
            countryCode: "JOR",
            initial: "yd",
            score: 0,
            countryCode2: "JO"
        },
        {
            id: 84,
            en: "Kampuchea (Cambodia )",
            zhCn: "柬埔寨",
            zhTw: "柬埔寨",
            areaCode: "+855",
            countryCode: "KHM",
            initial: "jbz",
            score: 0,
            countryCode2: "KH"
        },
        {
            id: 85,
            en: "Kazakstan",
            zhCn: "哈萨克斯坦",
            zhTw: "哈薩克斯坦",
            areaCode: "+327",
            countryCode: "KAZ",
            initial: "hskst",
            score: 0,
            countryCode2: "KZ"
        },
        {
            id: 86,
            en: "Kenya",
            zhCn: "肯尼亚",
            zhTw: "肯尼亞",
            areaCode: "+254",
            countryCode: "KEN",
            initial: "kny",
            score: 0,
            countryCode2: "KE"
        },
        {
            id: 87,
            en: "Korea",
            zhCn: "韩国",
            zhTw: "韓國",
            areaCode: "+82",
            countryCode: "KOR",
            initial: "hg",
            score: 0,
            countryCode2: "KR"
        },
        {
            id: 88,
            en: "Kuwait",
            zhCn: "科威特",
            zhTw: "科威特",
            areaCode: "+965",
            countryCode: "KWT",
            initial: "kwt",
            score: 0,
            countryCode2: "KW"
        },
        {
            id: 89,
            en: "Kyrgyzstan",
            zhCn: "吉尔吉斯坦",
            zhTw: "吉爾吉斯坦",
            areaCode: "+331",
            countryCode: "KGZ",
            initial: "jejst",
            score: 0,
            countryCode2: "KG"
        },
        {
            id: 90,
            en: "Laos",
            zhCn: "老挝",
            zhTw: "老撾",
            areaCode: "+856",
            countryCode: "LAO",
            initial: "lw",
            score: 0,
            countryCode2: "LA"
        },
        {
            id: 91,
            en: "Latvia",
            zhCn: "拉脱维亚",
            zhTw: "拉脫維亞",
            areaCode: "+371",
            countryCode: "LVA",
            initial: "ltwy",
            score: 0,
            countryCode2: "LV"
        },
        {
            id: 92,
            en: "Lebanon",
            zhCn: "黎巴嫩",
            zhTw: "黎巴嫩",
            areaCode: "+961",
            countryCode: "LBN",
            initial: "lbn",
            score: 0,
            countryCode2: "LB"
        },
        {
            id: 93,
            en: "Lesotho",
            zhCn: "莱索托",
            zhTw: "萊索托",
            areaCode: "+266",
            countryCode: "LSO",
            initial: "lst",
            score: 0,
            countryCode2: "LS"
        },
        {
            id: 94,
            en: "Liberia",
            zhCn: "利比里亚",
            zhTw: "利比里亞",
            areaCode: "+231",
            countryCode: "LBR",
            initial: "lbly",
            score: 0,
            countryCode2: "LR"
        },
        {
            id: 95,
            en: "Libya",
            zhCn: "利比亚",
            zhTw: "利比亞",
            areaCode: "+218",
            countryCode: "LBY",
            initial: "lby",
            score: 0,
            countryCode2: "LY"
        },
        {
            id: 96,
            en: "Liechtenstein",
            zhCn: "列支敦士登",
            zhTw: "列支敦士登",
            areaCode: "+423",
            countryCode: "LIE",
            initial: "lzdsd",
            score: 0,
            countryCode2: "LI"
        },
        {
            id: 97,
            en: "Lithuania",
            zhCn: "立陶宛",
            zhTw: "立陶宛",
            areaCode: "+370",
            countryCode: "LTU",
            initial: "ltw",
            score: 0,
            countryCode2: "LT"
        },
        {
            id: 98,
            en: "Luxembourg",
            zhCn: "卢森堡",
            zhTw: "盧森堡",
            areaCode: "+352",
            countryCode: "LUX",
            initial: "lsb",
            score: 0,
            countryCode2: "LU"
        },
        {
            id: 99,
            en: "Macao",
            zhCn: "中国澳门",
            zhTw: "中國澳門",
            areaCode: "+853",
            countryCode: "MAC",
            initial: "zgam",
            score: 80,
            countryCode2: "MO"
        },
        {
            id: 100,
            en: "Madagascar",
            zhCn: "马达加斯加",
            zhTw: "馬達加斯加",
            areaCode: "+261",
            countryCode: "MDG",
            initial: "mdjsj",
            score: 0,
            countryCode2: "MG"
        },
        {
            id: 101,
            en: "Malawi",
            zhCn: "马拉维",
            zhTw: "馬拉維",
            areaCode: "+265",
            countryCode: "MWI",
            initial: "mlw",
            score: 0,
            countryCode2: "MW"
        },
        {
            id: 102,
            en: "Malaysia",
            zhCn: "马来西亚",
            zhTw: "馬來西亞",
            areaCode: "+60",
            countryCode: "MYS",
            initial: "mlxy",
            score: 0,
            countryCode2: "MY"
        },
        {
            id: 103,
            en: "Maldives",
            zhCn: "马尔代夫",
            zhTw: "馬爾代夫",
            areaCode: "+960",
            countryCode: "MDV",
            initial: "medf",
            score: 0,
            countryCode2: "MV"
        },
        {
            id: 104,
            en: "Mali",
            zhCn: "马里",
            zhTw: "馬里",
            areaCode: "+223",
            countryCode: "MLI",
            initial: "ml",
            score: 0,
            countryCode2: "ML"
        },
        {
            id: 105,
            en: "Malta",
            zhCn: "马耳他",
            zhTw: "馬耳他",
            areaCode: "+356",
            countryCode: "MLT",
            initial: "met",
            score: 0,
            countryCode2: "MT"
        },
        {
            id: 106,
            en: "Mariana Is",
            zhCn: "马里亚那群岛",
            zhTw: "馬里亞那群島",
            areaCode: "+1670",
            countryCode: "MNP",
            initial: "mlynqd",
            score: 0,
            countryCode2: "MP"
        },
        {
            id: 107,
            en: "Martinique",
            zhCn: "马提尼克",
            zhTw: "馬提尼克",
            areaCode: "+596",
            countryCode: "MTQ",
            initial: "mtnk",
            score: 0,
            countryCode2: "MQ"
        },
        {
            id: 108,
            en: "Mauritius",
            zhCn: "毛里求斯",
            zhTw: "毛里求斯",
            areaCode: "+230",
            countryCode: "MUS",
            initial: "mlqs",
            score: 0,
            countryCode2: "MU"
        },
        {
            id: 109,
            en: "Mexico",
            zhCn: "墨西哥",
            zhTw: "墨西哥",
            areaCode: "+52",
            countryCode: "MEX",
            initial: "mxg",
            score: 0,
            countryCode2: "MX"
        },
        {
            id: 110,
            en: "Moldova, Republic of",
            zhCn: "摩尔多瓦",
            zhTw: "摩爾多瓦",
            areaCode: "+373",
            countryCode: "MDA",
            initial: "medw",
            score: 0,
            countryCode2: "MD"
        },
        {
            id: 111,
            en: "Monaco",
            zhCn: "摩纳哥",
            zhTw: "摩納哥",
            areaCode: "+377",
            countryCode: "MCO",
            initial: "mng",
            score: 0,
            countryCode2: "MC"
        },
        {
            id: 112,
            en: "Mongolia",
            zhCn: "蒙古",
            zhTw: "蒙古",
            areaCode: "+976",
            countryCode: "MNG",
            initial: "mg",
            score: 0,
            countryCode2: "MN"
        },
        {
            id: 113,
            en: "Montserrat Is",
            zhCn: "蒙特塞拉特岛",
            zhTw: "蒙特塞拉特島",
            areaCode: "+1664",
            countryCode: "MSR",
            initial: "mtsltd",
            score: 0,
            countryCode2: "MS"
        },
        {
            id: 114,
            en: "Morocco",
            zhCn: "摩洛哥",
            zhTw: "摩洛哥",
            areaCode: "+212",
            countryCode: "MAR",
            initial: "mlg",
            score: 0,
            countryCode2: "MA"
        },
        {
            id: 115,
            en: "Mozambique",
            zhCn: "莫桑比克",
            zhTw: "莫桑比克",
            areaCode: "+258",
            countryCode: "MOZ",
            initial: "msbk",
            score: 0,
            countryCode2: "MZ"
        },
        {
            id: 116,
            en: "Namibia",
            zhCn: "纳米比亚",
            zhTw: "納米比亞",
            areaCode: "+264",
            countryCode: "NAM",
            initial: "nmby",
            score: 0,
            countryCode2: "NA"
        },
        {
            id: 117,
            en: "Nauru",
            zhCn: "瑙鲁",
            zhTw: "瑙魯",
            areaCode: "+674",
            countryCode: "NRU",
            initial: "nl",
            score: 0,
            countryCode2: "NR"
        },
        {
            id: 118,
            en: "Nepal",
            zhCn: "尼泊尔",
            zhTw: "尼泊爾",
            areaCode: "+977",
            countryCode: "NPL",
            initial: "npe",
            score: 0,
            countryCode2: "NP"
        },
        {
            id: 119,
            en: "Netherlands",
            zhCn: "荷兰",
            zhTw: "荷蘭",
            areaCode: "+31",
            countryCode: "NLD",
            initial: "hl",
            score: 0,
            countryCode2: "NL"
        },
        {
            id: 120,
            en: "New Zealand",
            zhCn: "新西兰",
            zhTw: "新西蘭",
            areaCode: "+64",
            countryCode: "NZL",
            initial: "xxl",
            score: 0,
            countryCode2: "NZ"
        },
        {
            id: 121,
            en: "Nicaragua",
            zhCn: "尼加拉瓜",
            zhTw: "尼加拉瓜",
            areaCode: "+505",
            countryCode: "NIC",
            initial: "njlg",
            score: 0,
            countryCode2: "NI"
        },
        {
            id: 122,
            en: "Niger",
            zhCn: "尼日尔",
            zhTw: "尼日爾",
            areaCode: "+227",
            countryCode: "NER",
            initial: "nre",
            score: 0,
            countryCode2: "NE"
        },
        {
            id: 123,
            en: "Nigeria",
            zhCn: "尼日利亚",
            zhTw: "尼日利亞",
            areaCode: "+234",
            countryCode: "NGA",
            initial: "nrly",
            score: 0,
            countryCode2: "NG"
        },
        {
            id: 124,
            en: "North Korea",
            zhCn: "朝鲜",
            zhTw: "朝鮮",
            areaCode: "+850",
            countryCode: "PRK",
            initial: "zx",
            score: 0,
            countryCode2: "KP"
        },
        {
            id: 125,
            en: "Norway",
            zhCn: "挪威",
            zhTw: "挪威",
            areaCode: "+47",
            countryCode: "NOR",
            initial: "nw",
            score: 0,
            countryCode2: "NO"
        },
        {
            id: 126,
            en: "Oman",
            zhCn: "阿曼",
            zhTw: "阿曼",
            areaCode: "+968",
            countryCode: "OMN",
            initial: "am",
            score: 0,
            countryCode2: "OM"
        },
        {
            id: 127,
            en: "Pakistan",
            zhCn: "巴基斯坦",
            zhTw: "巴基斯坦",
            areaCode: "+92",
            countryCode: "PAK",
            initial: "bjst",
            score: 0,
            countryCode2: "PK"
        },
        {
            id: 128,
            en: "Panama",
            zhCn: "巴拿马",
            zhTw: "巴拿馬",
            areaCode: "+507",
            countryCode: "PAN",
            initial: "bnm",
            score: 0,
            countryCode2: "PA"
        },
        {
            id: 129,
            en: "Papua New Cuinea",
            zhCn: "巴布亚新几内亚",
            zhTw: "巴布亞新幾內亞",
            areaCode: "+675",
            countryCode: "PNG",
            initial: "bbyxjny",
            score: 0,
            countryCode2: "PG"
        },
        {
            id: 130,
            en: "Paraguay",
            zhCn: "巴拉圭",
            zhTw: "巴拉圭",
            areaCode: "+595",
            countryCode: "PRY",
            initial: "blg",
            score: 0,
            countryCode2: "PY"
        },
        {
            id: 131,
            en: "Peru",
            zhCn: "秘鲁",
            zhTw: "秘魯",
            areaCode: "+51",
            countryCode: "PER",
            initial: "ml",
            score: 0,
            countryCode2: "PE"
        },
        {
            id: 132,
            en: "Philippines",
            zhCn: "菲律宾",
            zhTw: "菲律賓",
            areaCode: "+63",
            countryCode: "PHL",
            initial: "flb",
            score: 0,
            countryCode2: "PH"
        },
        {
            id: 133,
            en: "Poland",
            zhCn: "波兰",
            zhTw: "波蘭",
            areaCode: "+48",
            countryCode: "POL",
            initial: "bl",
            score: 0,
            countryCode2: "PL"
        },
        {
            id: 134,
            en: "French Polynesia",
            zhCn: "法属玻利尼西亚",
            zhTw: "法屬玻利尼西亞",
            areaCode: "+689",
            countryCode: "PYF",
            initial: "fsblnxy",
            score: 0,
            countryCode2: "PF"
        },
        {
            id: 135,
            en: "Portugal",
            zhCn: "葡萄牙",
            zhTw: "葡萄牙",
            areaCode: "+351",
            countryCode: "PRT",
            initial: "pty",
            score: 0,
            countryCode2: "PT"
        },
        {
            id: 136,
            en: "Puerto Rico",
            zhCn: "波多黎各",
            zhTw: "波多黎各",
            areaCode: "+1787",
            countryCode: "PRI",
            initial: "bdlg",
            score: 0,
            countryCode2: "PR"
        },
        {
            id: 137,
            en: "Qatar",
            zhCn: "卡塔尔",
            zhTw: "卡塔爾",
            areaCode: "+974",
            countryCode: "QAT",
            initial: "kte",
            score: 0,
            countryCode2: "QA"
        },
        {
            id: 138,
            en: "Romania",
            zhCn: "罗马尼亚",
            zhTw: "羅馬尼亞",
            areaCode: "+40",
            countryCode: "ROU",
            initial: "lmny",
            score: 0,
            countryCode2: "RO"
        },
        {
            id: 139,
            en: "Russia",
            zhCn: "俄罗斯",
            zhTw: "俄羅斯",
            areaCode: "+7",
            countryCode: "RUS",
            initial: "els",
            score: 0,
            countryCode2: "RU"
        },
        {
            id: 140,
            en: "Samoa Eastern",
            zhCn: "东萨摩亚(美)",
            zhTw: "東薩摩亞(美)",
            areaCode: "+684",
            countryCode: "ASM",
            initial: "dsmy(m)",
            score: 0,
            countryCode2: "AS"
        },
        {
            id: 141,
            en: "Samoa Western",
            zhCn: "西萨摩亚",
            zhTw: "西薩摩亞",
            areaCode: "+685",
            countryCode: "WSM",
            initial: "xsmy",
            score: 0,
            countryCode2: "WS"
        },
        {
            id: 142,
            en: "San Marino",
            zhCn: "圣马力诺",
            zhTw: "聖馬力諾",
            areaCode: "+378",
            countryCode: "SMR",
            initial: "smln",
            score: 0,
            countryCode2: "SM"
        },
        {
            id: 143,
            en: "Sao Tome and Principe",
            zhCn: "圣多美和普林西比",
            zhTw: "聖多美和普林西比",
            areaCode: "+239",
            countryCode: "STP",
            initial: "sdmhplxb",
            score: 0,
            countryCode2: "ST"
        },
        {
            id: 144,
            en: "Saudi Arabia",
            zhCn: "沙特阿拉伯",
            zhTw: "沙特阿拉伯",
            areaCode: "+966",
            countryCode: "SAU",
            initial: "stelb",
            score: 0,
            countryCode2: "SA"
        },
        {
            id: 145,
            en: "Senegal",
            zhCn: "塞内加尔",
            zhTw: "塞內加爾",
            areaCode: "+221",
            countryCode: "SEN",
            initial: "snje",
            score: 0,
            countryCode2: "SN"
        },
        {
            id: 146,
            en: "Seychelles",
            zhCn: "塞舌尔",
            zhTw: "塞舌爾",
            areaCode: "+248",
            countryCode: "SYC",
            initial: "sse",
            score: 0,
            countryCode2: "SC"
        },
        {
            id: 147,
            en: "Sierra Leone",
            zhCn: "塞拉利昂",
            zhTw: "塞拉利昂",
            areaCode: "+232",
            countryCode: "SLE",
            initial: "slla",
            score: 0,
            countryCode2: "SL"
        },
        {
            id: 148,
            en: "Singapore",
            zhCn: "新加坡",
            zhTw: "新加坡",
            areaCode: "+65",
            countryCode: "SGP",
            initial: "xjp",
            score: 50,
            countryCode2: "SG"
        },
        {
            id: 149,
            en: "Slovakia",
            zhCn: "斯洛伐克",
            zhTw: "斯洛伐克",
            areaCode: "+421",
            countryCode: "SVK",
            initial: "slfk",
            score: 0,
            countryCode2: "SK"
        },
        {
            id: 150,
            en: "Slovenia",
            zhCn: "斯洛文尼亚",
            zhTw: "斯洛文尼亞",
            areaCode: "+386",
            countryCode: "SVN",
            initial: "slwny",
            score: 0,
            countryCode2: "SI"
        },
        {
            id: 151,
            en: "Solomon Is",
            zhCn: "所罗门群岛",
            zhTw: "所羅門群島",
            areaCode: "+677",
            countryCode: "SLB",
            initial: "slmqd",
            score: 0,
            countryCode2: "SB"
        },
        {
            id: 152,
            en: "Somali",
            zhCn: "索马里",
            zhTw: "索馬里",
            areaCode: "+252",
            countryCode: "SOM",
            initial: "sml",
            score: 0,
            countryCode2: "SO"
        },
        {
            id: 153,
            en: "South Africa",
            zhCn: "南非",
            zhTw: "南非",
            areaCode: "+27",
            countryCode: "ZAF",
            initial: "nf",
            score: 0,
            countryCode2: "ZA"
        },
        {
            id: 154,
            en: "Spain",
            zhCn: "西班牙",
            zhTw: "西班牙",
            areaCode: "+34",
            countryCode: "ESP",
            initial: "xby",
            score: 0,
            countryCode2: "ES"
        },
        {
            id: 155,
            en: "Sri Lanka",
            zhCn: "斯里兰卡",
            zhTw: "斯里蘭卡",
            areaCode: "+94",
            countryCode: "LKA",
            initial: "sllk",
            score: 0,
            countryCode2: "LK"
        },
        {
            id: 156,
            en: "St.Lucia",
            zhCn: "圣卢西亚",
            zhTw: "聖盧西亞",
            areaCode: "+1758",
            countryCode: "LCA",
            initial: "slxy",
            score: 0,
            countryCode2: "LC"
        },
        {
            id: 157,
            en: "St.Vincent",
            zhCn: "圣文森特",
            zhTw: "聖文森特",
            areaCode: "+1784",
            countryCode: "VCT",
            initial: "swst",
            score: 0,
            countryCode2: "VC"
        },
        {
            id: 158,
            en: "Sudan",
            zhCn: "苏丹",
            zhTw: "蘇丹",
            areaCode: "+249",
            countryCode: "SDN",
            initial: "sd",
            score: 0,
            countryCode2: "SD"
        },
        {
            id: 159,
            en: "Suriname",
            zhCn: "苏里南",
            zhTw: "蘇里南",
            areaCode: "+597",
            countryCode: "SUR",
            initial: "sln",
            score: 0,
            countryCode2: "SR"
        },
        {
            id: 160,
            en: "Swaziland",
            zhCn: "斯威士兰",
            zhTw: "斯威士蘭",
            areaCode: "+268",
            countryCode: "SWZ",
            initial: "swsl",
            score: 0,
            countryCode2: "SZ"
        },
        {
            id: 161,
            en: "Sweden",
            zhCn: "瑞典",
            zhTw: "瑞典",
            areaCode: "+46",
            countryCode: "SWE",
            initial: "rd",
            score: 0,
            countryCode2: "SE"
        },
        {
            id: 162,
            en: "Switzerland",
            zhCn: "瑞士",
            zhTw: "瑞士",
            areaCode: "+41",
            countryCode: "CHE",
            initial: "rs",
            score: 0,
            countryCode2: "CH"
        },
        {
            id: 163,
            en: "Syria",
            zhCn: "叙利亚",
            zhTw: "敘利亞",
            areaCode: "+963",
            countryCode: "SYR",
            initial: "xly",
            score: 0,
            countryCode2: "SY"
        },
        {
            id: 164,
            en: "Taiwan",
            zhCn: "中国台湾",
            zhTw: "中國台灣",
            areaCode: "+886",
            countryCode: "TWN",
            initial: "zgtw",
            score: 70,
            countryCode2: "TW"
        },
        {
            id: 165,
            en: "Tajikstan",
            zhCn: "塔吉克斯坦",
            zhTw: "塔吉克斯坦",
            areaCode: "+992",
            countryCode: "TJK",
            initial: "tjkst",
            score: 0,
            countryCode2: "TJ"
        },
        {
            id: 166,
            en: "Tanzania",
            zhCn: "坦桑尼亚",
            zhTw: "坦桑尼亞",
            areaCode: "+255",
            countryCode: "TZA",
            initial: "tsny",
            score: 0,
            countryCode2: "TZ"
        },
        {
            id: 167,
            en: "Thailand",
            zhCn: "泰国",
            zhTw: "泰國",
            areaCode: "+66",
            countryCode: "THA",
            initial: "tg",
            score: 0,
            countryCode2: "TH"
        },
        {
            id: 168,
            en: "Togo",
            zhCn: "多哥",
            zhTw: "多哥",
            areaCode: "+228",
            countryCode: "TGO",
            initial: "dg",
            score: 0,
            countryCode2: "TG"
        },
        {
            id: 169,
            en: "Tonga",
            zhCn: "汤加",
            zhTw: "湯加",
            areaCode: "+676",
            countryCode: "TON",
            initial: "tj",
            score: 0,
            countryCode2: "TO"
        },
        {
            id: 170,
            en: "Trinidad and Tobago",
            zhCn: "特立尼达和多巴哥",
            zhTw: "特立尼達和多巴哥",
            areaCode: "+1809",
            countryCode: "TTO",
            initial: "tlndhdbg",
            score: 0,
            countryCode2: "TT"
        },
        {
            id: 171,
            en: "Tunisia",
            zhCn: "突尼斯",
            zhTw: "突尼斯",
            areaCode: "+216",
            countryCode: "TUN",
            initial: "tns",
            score: 0,
            countryCode2: "TN"
        },
        {
            id: 172,
            en: "Turkey",
            zhCn: "土耳其",
            zhTw: "土耳其",
            areaCode: "+90",
            countryCode: "TUR",
            initial: "teq",
            score: 0,
            countryCode2: "TR"
        },
        {
            id: 173,
            en: "Turkmenistan",
            zhCn: "土库曼斯坦",
            zhTw: "土庫曼斯坦",
            areaCode: "+993",
            countryCode: "TKM",
            initial: "tkmst",
            score: 0,
            countryCode2: "TM"
        },
        {
            id: 174,
            en: "Uganda",
            zhCn: "乌干达",
            zhTw: "烏干達",
            areaCode: "+256",
            countryCode: "UGA",
            initial: "wgd",
            score: 0,
            countryCode2: "UG"
        },
        {
            id: 175,
            en: "Ukraine",
            zhCn: "乌克兰",
            zhTw: "烏克蘭",
            areaCode: "+380",
            countryCode: "UKR",
            initial: "wkl",
            score: 0,
            countryCode2: "UA"
        },
        {
            id: 176,
            en: "United Arab Emirates",
            zhCn: "阿拉伯联合酋长国",
            zhTw: "阿拉伯聯合酋長國",
            areaCode: "+971",
            countryCode: "ARE",
            initial: "elblhqcg",
            score: 0,
            countryCode2: "AE"
        },
        {
            id: 177,
            en: "United Kingdom",
            zhCn: "英国",
            zhTw: "英國",
            areaCode: "+44",
            countryCode: "GBR",
            initial: "yg",
            score: 0,
            countryCode2: "GB"
        },
        {
            id: 178,
            en: "United States of America",
            zhCn: "美国",
            zhTw: "美國",
            areaCode: "+1",
            countryCode: "USA",
            initial: "mg",
            score: 60,
            countryCode2: "US"
        },
        {
            id: 179,
            en: "Uruguay",
            zhCn: "乌拉圭",
            zhTw: "烏拉圭",
            areaCode: "+598",
            countryCode: "URY",
            initial: "wlg",
            score: 0,
            countryCode2: "UY"
        },
        {
            id: 180,
            en: "Uzbekistan",
            zhCn: "乌兹别克斯坦",
            zhTw: "烏茲別克斯坦",
            areaCode: "+233",
            countryCode: "UZB",
            initial: "wcbkst",
            score: 0,
            countryCode2: "UZ"
        },
        {
            id: 181,
            en: "Venezuela",
            zhCn: "委内瑞拉",
            zhTw: "委內瑞拉",
            areaCode: "+58",
            countryCode: "VEN",
            initial: "wnrl",
            score: 0,
            countryCode2: "VE"
        },
        {
            id: 182,
            en: "Vietnam",
            zhCn: "越南",
            zhTw: "越南",
            areaCode: "+84",
            countryCode: "VNM",
            initial: "yn",
            score: 0,
            countryCode2: "VN"
        },
        {
            id: 183,
            en: "Yemen",
            zhCn: "也门",
            zhTw: "也門",
            areaCode: "+967",
            countryCode: "YEM",
            initial: "ym",
            score: 0,
            countryCode2: "YE"
        },
        {
            id: 184,
            en: "Zimbabwe",
            zhCn: "津巴布韦",
            zhTw: "津巴布韋",
            areaCode: "+263",
            countryCode: "ZWE",
            initial: "jbbw",
            score: 0,
            countryCode2: "ZW"
        },
        {
            id: 185,
            en: "Zambia",
            zhCn: "赞比亚",
            zhTw: "贊比亞",
            areaCode: "+260",
            countryCode: "ZMB",
            initial: "zby",
            score: 0,
            countryCode2: "ZM"
        },
        {
            id: 186,
            en: "AmericanSamoa",
            zhCn: "美国萨摩亚",
            zhTw: "美國薩摩亞",
            areaCode: "+684",
            countryCode: "ASM",
            initial: "mgsmy",
            score: 0,
            countryCode2: "AS"
        },
        {
            id: 187,
            en: "British Virgin Islands",
            zhCn: "英属维尔京群岛",
            zhTw: "英屬維爾京群島",
            areaCode: "+1284",
            countryCode: "VGB",
            initial: "vg",
            score: 0,
            countryCode2: "VG"
        },
        {
            id: 188,
            en: "Vanuatu",
            zhCn: "瓦努阿图",
            zhTw: "瓦努阿圖",
            areaCode: "+678",
            countryCode: "VUT",
            initial: "wnat",
            score: 0,
            countryCode2: "VU"
        },
        {
            id: 189,
            en: "Palau",
            zhCn: "帕劳",
            zhTw: "帕勞",
            areaCode: "+680",
            countryCode: "PLW",
            initial: "pl",
            score: 0,
            countryCode2: "PW"
        },
        {
            id: 190,
            en: "Marshall Islands",
            zhCn: "马绍尔群岛",
            zhTw: "馬紹爾群島",
            areaCode: "+692",
            countryCode: "MHL",
            initial: "mseqd",
            score: 0,
            countryCode2: "MH"
        },
        {
            id: 191,
            en: "Saint Kitts and Nevis",
            zhCn: "圣基茨和尼维斯",
            zhTw: "聖基茨和尼維斯",
            areaCode: "+1869",
            countryCode: "KNA",
            initial: "sjchnws",
            score: 0,
            countryCode2: "KN"
        },
        {
            id: 192,
            en: "Bhutan",
            zhCn: "不丹",
            zhTw: "不丹",
            areaCode: "+975",
            countryCode: "BTN",
            initial: "bd",
            score: 0,
            countryCode2: "BT"
        },
        {
            id: 193,
            en: "Cape Verde",
            zhCn: "佛得角",
            zhTw: "佛得角",
            areaCode: "+238",
            countryCode: "CPV",
            initial: "fdj",
            score: 0,
            countryCode2: "CV"
        },
        {
            id: 194,
            en: "Comoros",
            zhCn: "科摩罗",
            zhTw: "科摩羅",
            areaCode: "+269",
            countryCode: "COM",
            initial: "kml",
            score: 0,
            countryCode2: "KM"
        },
        {
            id: 195,
            en: "Croatia",
            zhCn: "克罗地亚",
            zhTw: "克羅地亞",
            areaCode: "+385",
            countryCode: "HRV",
            initial: "klyy",
            score: 0,
            countryCode2: "HR"
        },
        {
            id: 196,
            en: "Dominican Republic",
            zhCn: "多米尼加共和国",
            zhTw: "多米尼加共和國",
            areaCode: "+1809",
            countryCode: "DOM",
            initial: "dmnjghg",
            score: 0,
            countryCode2: "DO"
        },
        {
            id: 197,
            en: "Equatorial Guinea",
            zhCn: "赤道几内亚",
            zhTw: "赤道幾內亞",
            areaCode: "+240",
            countryCode: "GNQ",
            initial: "cdjny",
            score: 0,
            countryCode2: "GQ"
        },
        {
            id: 198,
            en: "Kiribati",
            zhCn: "基里巴斯",
            zhTw: "基里巴斯",
            areaCode: "+686",
            countryCode: "KIR",
            initial: "jlbs",
            score: 0,
            countryCode2: "KI"
        },
        {
            id: 199,
            en: "Mauritania",
            zhCn: "毛里塔尼亚",
            zhTw: "毛里塔尼亞",
            areaCode: "+222",
            countryCode: "MRT",
            initial: "mltny",
            score: 0,
            countryCode2: "MR"
        },
        {
            id: 200,
            en: "Micronesia",
            zhCn: "密克罗尼西亚联邦",
            zhTw: "密克羅尼西亞聯邦",
            areaCode: "+691",
            countryCode: "FSM",
            initial: "mklnsylb",
            score: 0,
            countryCode2: "FM"
        },
        {
            id: 201,
            en: "North Macedonia",
            zhCn: "北马其顿",
            zhTw: "北馬其頓",
            areaCode: "+389",
            countryCode: "MKD",
            initial: "bmqd",
            score: 0,
            countryCode2: "MK"
        },
        {
            id: 202,
            en: "Timor-Leste",
            zhCn: "东帝汶",
            zhTw: "東帝汶",
            areaCode: "+670",
            countryCode: "TLS",
            initial: "ddw",
            score: 0,
            countryCode2: "TL"
        },
        {
            id: 203,
            en: "Tuvalu",
            zhCn: "图瓦卢",
            zhTw: "圖瓦盧",
            areaCode: "+688",
            countryCode: "TUV",
            initial: "twl",
            score: 0,
            countryCode2: "TV"
        },
        {
            id: 204,
            en: "Vatican City",
            zhCn: "梵蒂冈",
            zhTw: "梵蒂岡",
            areaCode: "+379",
            countryCode: "VAT",
            initial: "fdg",
            score: 0,
            countryCode2: "VA"
        },
        {
            id: 205,
            en: "Palestine",
            zhCn: "巴勒斯坦",
            zhTw: "巴勒斯坦國",
            areaCode: "+970",
            countryCode: "PSE",
            initial: "blst",
            score: 0,
            countryCode2: "PS"
        },
        {
            id: 206,
            en: "Niue",
            zhCn: "纽埃",
            zhTw: "紐埃",
            areaCode: "+683",
            countryCode: "NIU",
            initial: "na",
            score: 0,
            countryCode2: "NU"
        }
    ]

// 两位 国家码
export const CountryCodeMap = {
    CN: '中国内地',
    HK: '中国香港',
    MO: '中国澳门',
    TW: '中国台湾',
    US: '美国',
    AD: '安道尔',
    AE: '阿拉伯联合酋长国',
    AF: '阿富汗',
    AG: '安提瓜和巴布达',
    AI: '安圭拉',
    AL: '阿尔巴尼亚',
    AM: '亚美尼亚',
    AO: '安哥拉',
    AQ: '南极洲',
    AR: '阿根廷',
    AS: '美国萨摩亚',
    AT: '奥地利',
    AU: '澳大利亚',
    AW: '阿鲁巴',
    AX: '奥兰群岛',
    AZ: '阿塞拜疆',
    BA: '波斯尼亚和黑塞哥维那',
    BB: '巴巴多斯',
    BD: '孟加拉国',
    BE: '比利时',
    BF: '布基纳法索',
    BG: '保加利亚',
    BH: '巴林',
    BI: '布隆迪',
    BJ: '贝宁',
    BL: '圣巴泰勒米岛',
    BM: '百慕大',
    BN: '文莱达鲁萨兰国',
    BO: '玻利维亚州',
    BQ: '博纳尔，尤金和萨巴',
    BR: '巴西',
    BS: '巴哈马',
    BT: '不丹',
    BV: '布瓦岛',
    BW: '博茨瓦纳',
    BY: '白俄罗斯',
    BZ: '伯利兹',
    CA: '加拿大',
    CC: '科科斯（基林）群岛',
    CD: '刚果民主共和国',
    CF: '中非共和国',
    CG: '刚果',
    CH: '瑞士',
    CI: '科特迪瓦',
    CK: '库克群岛',
    CL: '智利',
    CM: '喀麦隆',
    CO: '哥伦比亚',
    CR: '哥斯达黎加',
    CU: '古巴',
    CV: '佛得角',
    CW: '库拉索',
    CX: '圣诞岛',
    CY: '塞浦路斯',
    CZ: '捷克共和国',
    DE: '德国',
    DJ: '吉布提',
    DK: '丹麦',
    DM: '多米尼克',
    DO: '多米尼加共和国',
    DZ: '阿尔及利亚',
    EC: '厄瓜多尔',
    EE: '爱沙尼亚',
    EG: '埃及',
    EH: '撒哈拉沙漠西部',
    ER: '厄立特里亚',
    ES: '西班牙',
    ET: '埃塞俄比亚',
    FI: '芬兰',
    FJ: '斐济',
    FK: '福克兰群岛（马尔维纳斯）',
    FM: '密克罗尼西亚联邦',
    FO: '法罗群岛',
    FR: '法国',
    GA: '加蓬',
    GB: '英国',
    GD: '格林纳达',
    GE: '格鲁吉亚',
    GF: '法属圭亚那',
    GG: '根西',
    GH: '加纳',
    GI: '吉拉塔尔',
    GL: '格陵兰',
    GM: '冈比亚',
    GN: '几内亚',
    GP: '瓜德罗普岛',
    GQ: '赤道几内亚',
    GR: '希腊',
    GS: '南乔治亚州和南桑威奇群岛',
    GT: '危地马拉',
    GU: '关岛',
    GW: '几内亚比绍',
    GY: '圭亚那',
    HM: '赫德岛和麦当劳岛',
    HN: '洪都拉斯',
    HR: '克罗地亚',
    HT: '海地',
    HU: '匈牙利',
    ID: '印度尼西亚',
    IE: '爱尔兰',
    IL: '以色列',
    IM: '马恩岛',
    IN: '印度',
    IO: '英属印度洋领地',
    IQ: '伊拉克',
    IR: '伊朗伊斯兰共和国',
    IS: '冰岛',
    IT: '意大利',
    JE: '泽西',
    JM: '牙买加',
    JO: '约旦',
    JP: '日本',
    KE: '肯尼亚',
    KG: '吉尔吉斯斯坦',
    KH: '柬埔寨',
    KI: '基里巴斯',
    KM: '科摩罗',
    KN: '圣基茨和尼维斯',
    KR: '韩国',
    KP: '朝鲜',
    KW: '科威特',
    KY: '开曼群岛',
    KZ: '哈萨克斯坦',
    LA: '老挝',
    LB: '黎巴嫩',
    LC: '圣卢西亚',
    LI: '列支敦士登',
    LK: '斯里兰卡',
    LR: '利比里亚',
    LS: '莱索托',
    LT: '立陶宛',
    LU: '卢森堡',
    LV: '拉脱维亚',
    LY: '利比亚',
    MA: '摩洛哥',
    MC: '摩纳哥',
    MD: '摩尔多瓦共和国',
    ME: '黑山',
    MF: '圣马丁（法语部分）',
    MG: '马达加斯加',
    MH: '马绍尔群岛',
    MK: '北马其顿',
    ML: '马里',
    MM: '缅甸',
    MN: '蒙古',
    MP: '北马里亚纳群岛',
    MQ: '马提尼克',
    MR: '毛里塔尼亚',
    MS: '蒙特塞拉特',
    MT: '马耳他',
    MU: '毛里求斯',
    MV: '马尔代夫',
    MW: '马拉维',
    MX: '墨西哥',
    MY: '马来西亚',
    MZ: '莫桑比克',
    NA: '纳米比亚',
    NC: '新喀里多尼亚',
    NE: '尼日尔',
    NF: '诺福克岛',
    NG: '尼日利亚',
    NI: '尼加拉瓜',
    NL: '荷兰',
    NO: '挪威',
    NP: '尼泊尔',
    NR: '瑙鲁',
    NU: '纽埃',
    NZ: '新西兰',
    OM: '阿曼',
    PA: '巴拿马',
    PE: '秘鲁',
    PF: '法属波利尼西亚',
    PG: '巴布亚新几内亚',
    PH: '菲律宾',
    PK: '巴基斯坦',
    PL: '波兰',
    PM: '圣皮埃尔和密克隆',
    PN: '皮特凯恩',
    PR: '波多黎各',
    PS: '巴勒斯坦国',
    PT: '葡萄牙',
    PW: '帕劳',
    PY: '巴拉圭',
    QA: '卡塔尔',
    RE: '留尼汪岛',
    RO: '罗马尼亚',
    RU: '俄罗斯',
    RW: '卢旺达',
    SA: '沙特阿拉伯',
    SB: '所罗门群岛',
    SC: '塞舌尔',
    SD: '苏丹',
    SE: '瑞典',
    SG: '新加坡',
    SH: '圣海伦娜，阿松森和圣赫勒拿',
    SI: '斯洛文尼亚',
    SJ: '斯瓦尔巴德和简梅恩',
    SK: '斯洛伐克',
    SL: '塞拉利昂',
    SM: '圣马力诺',
    SN: '塞内加尔',
    SO: '索马里',
    SR: '苏里南',
    SS: '南苏丹',
    ST: '圣多美和普林西比',
    SV: '萨尔瓦多',
    SX: '圣马丁（荷兰部分）',
    SY: '叙利亚',
    SZ: '斯威士兰',
    TC: '特克斯和凯科斯群岛',
    TD: '乍得',
    TF: '法国南部地区',
    TG: '多哥',
    TH: '泰国',
    TJ: '塔吉克斯坦',
    TK: '托克劳群岛',
    TL: '东帝汶',
    TM: '土库曼斯坦',
    TN: '突尼斯',
    TO: '汤加',
    TR: '土耳其',
    TT: '特立尼达和多巴哥',
    TV: '图瓦卢',
    TZ: '坦桑尼亚',
    UA: '乌克兰',
    UG: '乌干达',
    UM: '美国离岛偏远地区',
    UY: '乌拉圭',
    UZ: '乌兹别克斯坦',
    VA: '梵蒂冈',
    VC: '圣文森特',
    VE: '委内瑞拉',
    VG: '英属维尔京群岛',
    VI: '美国维尔京群岛',
    VN: '越南',
    VU: '瓦努阿图',
    WF: '瓦利斯和富纳',
    WS: '萨摩亚',
    YE: '也门',
    YT: '马约特',
    ZA: '南非',
    ZM: '赞比亚',
    ZW: '津巴布韦',
}

export const CountryCodeMapTc = {
    AD: '安道爾',
    AE: '阿拉伯聯合酋長國',
    AF: '阿富汗',
    AG: '安提瓜和巴布達',
    AI: '安圭拉',
    AL: '阿爾巴尼亞',
    AM: '亞美尼亞',
    AO: '安哥拉',
    AQ: '南極洲',
    AR: '阿根廷',
    AS: '美國薩摩亞',
    AT: '奧地利',
    AU: '澳大利亞',
    AW: '阿魯巴',
    AX: '奧蘭群島',
    AZ: '阿塞拜疆',
    BA: '波斯尼亞和黑塞哥維那',
    BB: '巴巴多斯',
    BD: '孟加拉國',
    BE: '比利時',
    BF: '布基納法索',
    BG: '保加利亞',
    BH: '巴林',
    BI: '布隆迪',
    BJ: '貝寧',
    BL: '聖巴泰勒米島',
    BM: '百慕大',
    BN: '文萊達魯薩蘭國',
    BO: '玻利維亞州',
    BQ: '博納爾，尤金和薩巴',
    BR: '巴西',
    BS: '巴哈馬',
    BT: '不丹',
    BV: '布瓦島',
    BW: '博茨瓦納',
    BY: '白俄羅斯',
    BZ: '伯利茲',
    CA: '加拿大',
    CC: '科科斯（基林）群島',
    CD: '剛果民主共和國',
    CF: '中非共和國',
    CG: '剛果',
    CH: '瑞士',
    CI: '科特迪瓦',
    CK: '庫克群島',
    CL: '智利',
    CM: '喀麥隆',
    CN: '中國內地',
    CO: '哥倫比亞',
    CR: '哥斯達黎加',
    CU: '古巴',
    CV: '佛得角',
    CW: '庫拉索',
    CX: '聖誕島',
    CY: '塞浦路斯',
    CZ: '捷克共和國',
    DE: '德國',
    DJ: '吉布提',
    DK: '丹麥',
    DM: '多米尼克',
    DO: '多米尼加共和國',
    DZ: '阿爾及利亞',
    EC: '厄瓜多爾',
    EE: '愛沙尼亞',
    EG: '埃及',
    EH: '撒哈拉沙漠西部',
    ER: '厄立特裏亞',
    ES: '西班牙',
    ET: '埃塞俄比亞',
    FI: '芬蘭',
    FJ: '斐濟',
    FK: '福克蘭群島（馬爾維納斯）',
    FM: '密克羅尼西亞聯邦',
    FO: '法羅群島',
    FR: '法國',
    GA: '加蓬',
    GB: '英國',
    GD: '格林納達',
    GE: '格魯吉亞',
    GF: '法屬圭亞那',
    GG: '根西',
    GH: '加納',
    GI: '吉拉塔爾',
    GL: '格陵蘭',
    GM: '岡比亞',
    GN: '幾內亞',
    GP: '瓜德羅普島',
    GQ: '赤道幾內亞',
    GR: '希臘',
    GS: '南喬治亞州和南桑威奇群島',
    GT: '危地馬拉',
    GU: '關島',
    GW: '幾內亞比紹',
    GY: '圭亞那',
    HK: '中國香港',
    HM: '赫德島和麥當勞島',
    HN: '洪都拉斯',
    HR: '克羅地亞',
    HT: '海地',
    HU: '匈牙利',
    ID: '印度尼西亞',
    IE: '愛爾蘭',
    IL: '以色列',
    IM: '馬恩島',
    IN: '印度',
    IO: '英屬印度洋領地',
    IQ: '伊拉克',
    IR: '伊朗伊斯蘭共和國',
    IS: '冰島',
    IT: '意大利',
    JE: '澤西',
    JM: '牙買加',
    JO: '約旦',
    JP: '日本',
    KE: '肯尼亞',
    KG: '吉爾吉斯斯坦',
    KH: '柬埔寨',
    KI: '基裏巴斯',
    KM: '科摩羅',
    KN: '聖基茨和尼維斯',
    KR: '韓國',
    KP: '北韓',
    KW: '科威特',
    KY: '開曼群島',
    KZ: '哈薩克斯坦',
    LA: '老撾人民民主共和國',
    LB: '黎巴嫩',
    LC: '聖盧西亞',
    LI: '列支敦士登',
    LK: '斯裏蘭卡',
    LR: '利比裏亞',
    LS: '萊索托',
    LT: '立陶宛',
    LU: '盧森堡',
    LV: '拉脫維亞',
    LY: '利比亞',
    MA: '摩洛哥',
    MC: '摩納哥',
    MD: '摩爾多瓦共和國',
    ME: '黑山',
    MF: '聖馬丁（法語部分）',
    MG: '馬達加斯加',
    MH: '馬紹爾群島',
    MK: '北馬其頓',
    ML: '馬裏',
    MM: '緬甸',
    MN: '蒙古',
    MO: '中國澳門',
    MP: '北馬裏亞納群島',
    MQ: '馬提尼克',
    MR: '毛裏塔尼亞',
    MS: '蒙特塞拉特',
    MT: '馬耳他',
    MU: '毛裏求斯',
    MV: '馬爾代夫',
    MW: '馬拉維',
    MX: '墨西哥',
    MY: '馬來西亞',
    MZ: '莫桑比克',
    NA: '納米比亞',
    NC: '新喀裏多尼亞',
    NE: '尼日爾',
    NF: '諾福克島',
    NG: '尼日利亞',
    NI: '尼加拉瓜',
    NL: '荷蘭',
    NO: '挪威',
    NP: '尼泊爾',
    NR: '瑙魯',
    NU: '紐埃',
    NZ: '新西蘭',
    OM: '阿曼',
    PA: '巴拿馬',
    PE: '秘魯',
    PF: '法屬波利尼西亞',
    PG: '巴布亞新幾內亞',
    PH: '菲律賓',
    PK: '巴基斯坦',
    PL: '波蘭',
    PM: '聖皮埃爾和密克隆',
    PN: '皮特凱恩',
    PR: '波多黎各',
    PS: '巴勒斯坦國',
    PT: '葡萄牙',
    PW: '帕勞',
    PY: '巴拉圭',
    QA: '卡塔爾',
    RE: '留尼汪島',
    RO: '羅馬尼亞',
    RU: '俄羅斯聯邦',
    RW: '盧旺達',
    SA: '沙特阿拉伯',
    SB: '所羅門群島',
    SC: '塞舌爾',
    SD: '蘇丹',
    SE: '瑞典',
    SG: '新加坡',
    SH: '聖海倫娜，阿松森和聖赫勒拿',
    SI: '斯洛文尼亞語',
    SJ: '斯瓦爾巴德和簡梅恩',
    SK: '斯洛伐克',
    SL: '塞拉利昂',
    SM: '聖馬力諾',
    SN: '塞內加爾',
    SO: '索馬裏',
    SR: '蘇裏南',
    SS: '南蘇丹',
    ST: '聖多美和普林西比',
    SV: '薩爾瓦多',
    SX: '聖馬丁（荷蘭部分）',
    SY: '阿拉伯敘利亞共和國',
    SZ: '斯威士蘭',
    TC: '特克斯和凱科斯群島',
    TD: '乍得',
    TF: '法國南部地區',
    TG: '多哥',
    TH: '泰國',
    TJ: '塔吉克斯坦',
    TK: '托克勞群島',
    TL: '東帝汶',
    TM: '土庫曼斯坦',
    TN: '突尼斯',
    TO: '湯加',
    TR: '土耳其',
    TT: '特立尼達和多巴哥',
    TV: '圖瓦盧',
    TW: '中國台灣',
    TZ: '坦桑尼亞聯合共和國',
    UA: '烏克蘭',
    UG: '烏幹達',
    UM: '美國離島偏遠地區',
    US: '美國',
    UY: '烏拉圭',
    UZ: '烏茲別克斯坦',
    VA: '梵蒂岡',
    VC: '聖文森特和格林納丁斯',
    VE: '委內瑞拉玻利瓦爾共和國',
    VG: '英屬維爾京群島',
    VI: '美國維爾京群島',
    VN: '越南',
    VU: '瓦努阿圖',
    WF: '瓦利斯和富納',
    WS: '薩摩亞',
    YE: '也門',
    YT: '馬約特',
    ZA: '南非',
    ZM: '贊比亞',
    ZW: '津巴布韋',
}

export const CountryCodeMapEn = {
    CN: 'Mainland China',
    HK: 'Hong Kong, China',
    MO: 'Macao, China',
    TW: 'Taiwan, China',
    US: 'United States',
    AD: 'Andorra',
    AE: 'United Arab Emirates',
    AF: 'Afghanistan',
    AG: 'Antigua and Barbuda',
    AI: 'Anguilla',
    AL: 'Albania',
    AM: 'Armenia',
    AO: 'Angola',
    AQ: 'Antarctica',
    AR: 'Argentina',
    AS: 'American Samoa',
    AT: 'Austria',
    AU: 'Australia',
    AW: 'Aruba',
    AX: 'Åland Islands',
    AZ: 'Azerbaijan',
    BA: 'Bosnia and Herzegovina',
    BB: 'Barbados',
    BD: 'Bangladesh',
    BE: 'Belgium',
    BF: 'Burkina Faso',
    BG: 'Bulgaria',
    BH: 'Bahrain',
    BI: 'Burundi',
    BJ: 'Benin',
    BL: 'Saint Barthélemy',
    BM: 'Bermuda',
    BN: 'Brunei Darussalam',
    BO: 'Bolivia',
    BQ: 'Bonaire, Sint Eustatius and Saba',
    BR: 'Brazil',
    BS: 'Bahamas',
    BT: 'Bhutan',
    BV: 'Bouvet Island',
    BW: 'Botswana',
    BY: 'Belarus',
    BZ: 'Belize',
    CA: 'Canada',
    CC: 'Cocos (Keeling) Islands',
    CD: 'Democratic Republic of the Congo',
    CF: 'Central African Republic',
    CG: 'Congo',
    CH: 'Switzerland',
    CI: "Côte d'Ivoire",
    CK: 'Cook Islands',
    CL: 'Chile',
    CM: 'Cameroon',
    CO: 'Colombia',
    CR: 'Costa Rica',
    CU: 'Cuba',
    CV: 'Cape Verde',
    CW: 'Curaçao',
    CX: 'Christmas Island',
    CY: 'Cyprus',
    CZ: 'Czech Republic',
    DE: 'Germany',
    DJ: 'Djibouti',
    DK: 'Denmark',
    DM: 'Dominica',
    DO: 'Dominican Republic',
    DZ: 'Algeria',
    EC: 'Ecuador',
    EE: 'Estonia',
    EG: 'Egypt',
    EH: 'Western Sahara',
    ER: 'Eritrea',
    ES: 'Spain',
    ET: 'Ethiopia',
    FI: 'Finland',
    FJ: 'Fiji',
    FK: 'Falkland Islands (Malvinas)',
    FM: 'Micronesia',
    FO: 'Faroe Islands',
    FR: 'France',
    GA: 'Gabon',
    GB: 'United Kingdom',
    GD: 'Grenada',
    GE: 'Georgia',
    GF: 'French Guiana',
    GG: 'Guernsey',
    GH: 'Ghana',
    GI: 'Gibraltar',
    GL: 'Greenland',
    GM: 'Gambia',
    GN: 'Guinea',
    GP: 'Guadeloupe',
    GQ: 'Equatorial Guinea',
    GR: 'Greece',
    GS: 'South Georgia and the South Sandwich Islands',
    GT: 'Guatemala',
    GU: 'Guam',
    GW: 'Guinea-Bissau',
    GY: 'Guyana',
    HM: 'Heard Island and McDonald Islands',
    HN: 'Honduras',
    HR: 'Croatia',
    HT: 'Haiti',
    HU: 'Hungary',
    ID: 'Indonesia',
    IE: 'Ireland',
    IL: 'Israel',
    IM: 'Isle of Man',
    IN: 'India',
    IO: 'British Indian Ocean Territory',
    IQ: 'Iraq',
    IR: 'Iran',
    IS: 'Iceland',
    IT: 'Italy',
    JE: 'Jersey',
    JM: 'Jamaica',
    JO: 'Jordan',
    JP: 'Japan',
    KE: 'Kenya',
    KG: 'Kyrgyzstan',
    KH: 'Cambodia',
    KI: 'Kiribati',
    KM: 'Comoros',
    KN: 'Saint Kitts and Nevis',
    KR: 'South Korea',
    KP: 'North Korea',
    KW: 'Kuwait',
    KY: 'Cayman Islands',
    KZ: 'Kazakhstan',
    LA: 'Laos',
    LB: 'Lebanon',
    LC: 'Saint Lucia',
    LI: 'Liechtenstein',
    LK: 'Sri Lanka',
    LR: 'Liberia',
    LS: 'Lesotho',
    LT: 'Lithuania',
    LU: 'Luxembourg',
    LV: 'Latvia',
    LY: 'Libya',
    MA: 'Morocco',
    MC: 'Monaco',
    MD: 'Moldova',
    ME: 'Montenegro',
    MF: 'Saint Martin (French part)',
    MG: 'Madagascar',
    MH: 'Marshall Islands',
    MK: 'North Macedonia',
    ML: 'Mali',
    MM: 'Myanmar',
    MN: 'Mongolia',
    MP: 'Northern Mariana Islands',
    MQ: 'Martinique',
    MR: 'Mauritania',
    MS: 'Montserrat',
    MT: 'Malta',
    MU: 'Mauritius',
    MV: 'Maldives',
    MW: 'Malawi',
    MX: 'Mexico',
    MY: 'Malaysia',
    MZ: 'Mozambique',
    NA: 'Namibia',
    NC: 'New Caledonia',
    NE: 'Niger',
    NF: 'Norfolk Island',
    NG: 'Nigeria',
    NI: 'Nicaragua',
    NL: 'Netherlands',
    NO: 'Norway',
    NP: 'Nepal',
    NR: 'Nauru',
    NU: 'Niue',
    NZ: 'New Zealand',
    OM: 'Oman',
    PA: 'Panama',
    PE: 'Peru',
    PF: 'French Polynesia',
    PG: 'Papua New Guinea',
    PH: 'Philippines',
    PK: 'Pakistan',
    PL: 'Poland',
    PM: 'Saint Pierre and Miquelon',
    PN: 'Pitcairn',
    PR: 'Puerto Rico',
    PS: 'Palestine',
    PT: 'Portugal',
    PW: 'Palau',
    PY: 'Paraguay',
    QA: 'Qatar',
    RE: 'Réunion',
    RO: 'Romania',
    RU: 'Russia',
    RW: 'Rwanda',
    SA: 'Saudi Arabia',
    SB: 'Solomon Islands',
    SC: 'Seychelles',
    SD: 'Sudan',
    SE: 'Sweden',
    SG: 'Singapore',
    SH: 'Saint Helena, Ascension and Tristan da Cunha',
    SI: 'Slovenia',
    SJ: 'Svalbard and Jan Mayen',
    SK: 'Slovakia',
    SL: 'Sierra Leone',
    SM: 'San Marino',
    SN: 'Senegal',
    SO: 'Somalia',
    SR: 'Suriname',
    SS: 'South Sudan',
    ST: 'Sao Tome and Principe',
    SV: 'El Salvador',
    SX: 'Sint Maarten (Dutch part)',
    SY: 'Syria',
    SZ: 'Eswatini',
    TC: 'Turks and Caicos Islands',
    TD: 'Chad',
    TF: 'French Southern Territories',
    TG: 'Togo',
    TH: 'Thailand',
    TJ: 'Tajikistan',
    TK: 'Tokelau',
    TL: 'Timor-Leste',
    TM: 'Turkmenistan',
    TN: 'Tunisia',
    TO: 'Tonga',
    TR: 'Turkey',
    TT: 'Trinidad and Tobago',
    TV: 'Tuvalu',
    TZ: 'Tanzania',
    UA: 'Ukraine',
    UG: 'Uganda',
    UM: 'United States Minor Outlying Islands',
    UY: 'Uruguay',
    UZ: 'Uzbekistan',
    VA: 'Vatican City',
    VC: 'Saint Vincent and the Grenadines',
    VE: 'Venezuela',
    VG: 'British Virgin Islands',
    VI: 'U.S. Virgin Islands',
    VN: 'Vietnam',
    VU: 'Vanuatu',
    WF: 'Wallis and Futuna',
    WS: 'Samoa',
    YE: 'Yemen',
    YT: 'Mayotte',
    ZA: 'South Africa',
    ZM: 'Zambia',
    ZW: 'Zimbabwe',
}

/** 投资移民开户可以申请的国家*/
export const TzymProhibitCountry = ['AU', 'FR', 'IE', 'LU', 'MY', 'NL', 'CH', 'GB', 'TW', 'TH', 'DE', 'MO', 'CA', 'IT', 'JP', 'KR', 'SG', 'PT']

/** 香港开户允许的国家
 * 2023-1218调整
 * 需求：https://www.tapd.cn/60236733/prong/stories/view/1160236733001022708
 */
export const PermittedCountries = [
    'VG',
    // 'US',
    'HK',
    'PW',
    'TW',
    'KY',
    'SG',
    'CA',
    'MO',
    'AU',
    'GR',
    'PT',
    'WS',
    'SC',
    'FR',
    'JP',
    'NZ',
    'AT',
    'BR',
    'MY',
    'MH',
    'NL',
    'PH',
    'KN',
    'LC',
    'SE',
    'GB',
    'DM',
    'DE',
    'IN',
    'IL',
    'IT',
    'LU',
    'KR',
    'ES',
    'TH',
    'CK',
    'AI',
    'BM',
    'AL',
    'AD',
    'AG',
    'AR',
    'BS',
    'BH',
    'BD',
    'BB',
    'BE',
    'BZ',
    'BJ',
    'BT',
    'BW',
    'BN',
    'CV',
    'KH',
    'TD',
    'CL',
    'CN',
    'CO',
    'KM',
    'CG',
    'CR',
    'HR',
    'CY',
    'CZ',
    'DK',
    'DJ',
    'DO',
    'EC',
    'EG',
    'SV',
    'GQ',
    'EE',
    'SZ',
    'FJ',
    'FI',
    'GA',
    'GM',
    'GE',
    'GH',
    'GD',
    'GY',
    'HN',
    'HU',
    'IS',
    'ID',
    'IE',
    'JM',
    'JO',
    'KZ',
    'KI',
    'KW',
    'KG',
    'LV',
    'LS',
    'LI',
    'LT',
    'MG',
    'MW',
    'MV',
    'MT',
    'MR',
    'MU',
    'MX',
    'FM',
    'MN',
    'MA',
    'NR',
    'MK',
    'NO',
    'OM',
    'PK',
    'PA',
    'PG',
    'PY',
    'PE',
    'PL',
    'QA',
    'RO',
    'VC',
    'SM',
    'ST',
    'SA',
    'SN',
    'SK',
    'SI',
    'SB',
    'LK',
    'SR',
    'CH',
    'TJ',
    'TZ',
    'TL',
    'TG',
    'TO',
    'TT',
    'TM',
    'TV',
    'UG',
    'AE',
    'UY',
    'UZ',
    'VU',
    'ZM',
    'VA',
    'PS',
    'NU',
]
/** 通过两位国家码获取国家的英文名 不一定能匹配到 */
export const GetCodeToEn = code => {
    const name = CountryCodeMap[code]
    let callback = {}
    countrys.map(item => {
        if (item.zhCn == name) {
            callback = item
        }
    })
    return callback
}
